"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[5912],{

/***/ 90848:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FV": () => (/* reexport */ DraftStatus),
  "M8": () => (/* reexport */ FinalisedStatus),
  "hA": () => (/* reexport */ InvoiceActions),
  "m0": () => (/* reexport */ InvoiceMode)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Print.js
var Print = __webpack_require__(46298);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Delete.js
var Delete = __webpack_require__(7056);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceActions/types.ts
var FinalisedStatus = /* @__PURE__ */ ((FinalisedStatus2) => {
  FinalisedStatus2["PAID"] = "PAID";
  FinalisedStatus2["PARTIALLY_PAID"] = "PARTIALLY_PAID";
  FinalisedStatus2["UNPAID"] = "UNPAID";
  FinalisedStatus2["REFUNDED"] = "REFUNDED";
  FinalisedStatus2["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
  FinalisedStatus2["VOID"] = "VOID";
  return FinalisedStatus2;
})(FinalisedStatus || {});
var DraftStatus = /* @__PURE__ */ ((DraftStatus2) => {
  DraftStatus2["EMPTY"] = "EMPTY";
  DraftStatus2["POPULATED"] = "POPULATED";
  return DraftStatus2;
})(DraftStatus || {});
var InvoiceMode = /* @__PURE__ */ ((InvoiceMode2) => {
  InvoiceMode2["DRAFT"] = "DRAFT";
  InvoiceMode2["FINALISED"] = "FINALISED";
  return InvoiceMode2;
})(InvoiceMode || {});

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/ConditionalDisplay/index.ts + 1 modules
var ConditionalDisplay = __webpack_require__(7195);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/hooks/usePermissions.ts
var usePermissions = __webpack_require__(14344);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceActions/DraftActions.tsx









const DraftActions = ({
  printInvoice,
  deleteInvoice,
  finaliseInvoice,
  draftStatus
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const permissions = (0,usePermissions/* usePermissions */.TE)();
  const DeleteIconButton = () => /* @__PURE__ */ react.createElement(dist_module/* IconButton */.hU, {
    onClick: deleteInvoice == null ? void 0 : deleteInvoice.handleAction,
    disabled: deleteInvoice == null ? void 0 : deleteInvoice.disabled,
    color: "alert",
    "aria-label": formatMessage({
      id: "invoicing.invoice.draftActions.delete",
      defaultMessage: "Delete Invoice"
    })
  }, /* @__PURE__ */ react.createElement(Delete/* default */.Z, {
    fontSize: "large"
  }));
  const PrintIconButton = () => /* @__PURE__ */ react.createElement(dist_module/* IconButton */.hU, {
    onClick: printInvoice == null ? void 0 : printInvoice.handlePrintInvoice,
    disabled: printInvoice == null ? void 0 : printInvoice.disabled,
    "aria-label": formatMessage({
      id: "invoicing.invoice.finalisedActions.print.invoice",
      defaultMessage: "Print Invoice"
    })
  }, /* @__PURE__ */ react.createElement(Print/* default */.Z, {
    fontSize: "large"
  }));
  const FinaliseButton = () => /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "primary",
    onClick: finaliseInvoice == null ? void 0 : finaliseInvoice.handleAction,
    disabled: finaliseInvoice == null ? void 0 : finaliseInvoice.disabled
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.draftActions.finalise",
    defaultMessage: "Finalise"
  }));
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    justifyContent: "space-between",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: draftStatus === DraftStatus.POPULATED
  }, /* @__PURE__ */ react.createElement(PrintIconButton, null)), /* @__PURE__ */ react.createElement(DeleteIconButton, null)), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: draftStatus === DraftStatus.POPULATED && !finaliseInvoice.hide && permissions.finalise
  }, /* @__PURE__ */ react.createElement(FinaliseButton, null))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Menu/Menu.js
var Menu = __webpack_require__(99313);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(64432);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceActions/FinalisedActions.tsx








const FinalisedActions = ({
  printInvoice,
  refundInvoice,
  voidInvoice,
  takePayment,
  paymentHistory,
  finalisedStatus
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const permissions = (0,usePermissions/* usePermissions */.TE)();
  const PrintIconButton = () => {
    const [anchorEl, setAnchorEl] = react.useState(null);
    const open = Boolean(anchorEl);
    const handleClose = () => {
      setAnchorEl(null);
    };
    const handleOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleSelect = (print) => {
      handleClose();
      print();
    };
    return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(dist_module/* IconButton */.hU, {
      onClick: handleOpen,
      "aria-label": formatMessage({
        id: "invoicing.invoice.finalisedActions.print.choice",
        defaultMessage: "Print Receipt or Invoice"
      })
    }, /* @__PURE__ */ react.createElement(Print/* default */.Z, {
      fontSize: "large"
    })), /* @__PURE__ */ react.createElement(Menu/* default */.Z, {
      anchorEl,
      open,
      onClose: handleClose,
      MenuListProps: {
        "aria-labelledby": "basic-button"
      }
    }, /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
      onClick: () => handleSelect(printInvoice.handlePrintInvoice)
    }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "invoicing.invoice.finalisedActions.print.invoice",
      defaultMessage: "Print Invoice"
    })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
      condition: finalisedStatus !== FinalisedStatus.UNPAID && finalisedStatus !== FinalisedStatus.PARTIALLY_PAID
    }, /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
      onClick: () => handleSelect(printInvoice.handlePrintReceipt)
    }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "invoicing.invoice.finalisedActions.print.receipt",
      defaultMessage: "Print Receipt"
    })))));
  };
  const RefundButton = () => /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: refundInvoice && !refundInvoice.hide && permissions.refunds
  }, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "error",
    onClick: refundInvoice == null ? void 0 : refundInvoice.handleAction,
    style: { marginLeft: "16px" }
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.finalisedActions.refund",
    defaultMessage: "Refund"
  })));
  const TakePaymentButton = () => /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "primary",
    onClick: takePayment == null ? void 0 : takePayment.handleAction,
    style: { marginLeft: "16px" }
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.finalisedActions.takePayment",
    defaultMessage: "Take Payment"
  }));
  const PaymentHistoryButton = () => /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "secondary",
    onClick: paymentHistory == null ? void 0 : paymentHistory.handleAction
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.finalisedActions.paymentHistory",
    defaultMessage: "Payment History"
  }));
  const VoidButton = () => /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: permissions.void
  }, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "error",
    onClick: voidInvoice == null ? void 0 : voidInvoice.handleAction
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.finalisedActions.void",
    defaultMessage: "Void"
  })));
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    justifyContent: "space-between",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, /* @__PURE__ */ react.createElement(PrintIconButton, null)), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: finalisedStatus === FinalisedStatus.PAID
  }, /* @__PURE__ */ react.createElement(PaymentHistoryButton, null), /* @__PURE__ */ react.createElement(RefundButton, null)), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: finalisedStatus === FinalisedStatus.PARTIALLY_PAID
  }, /* @__PURE__ */ react.createElement(PaymentHistoryButton, null), /* @__PURE__ */ react.createElement(RefundButton, null), /* @__PURE__ */ react.createElement(TakePaymentButton, null)), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: finalisedStatus === FinalisedStatus.UNPAID
  }, /* @__PURE__ */ react.createElement(VoidButton, null), /* @__PURE__ */ react.createElement(TakePaymentButton, null)), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: finalisedStatus === FinalisedStatus.PARTIALLY_REFUNDED
  }, /* @__PURE__ */ react.createElement(PaymentHistoryButton, null), /* @__PURE__ */ react.createElement(RefundButton, null)), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: finalisedStatus === FinalisedStatus.REFUNDED || finalisedStatus === FinalisedStatus.VOID
  }, /* @__PURE__ */ react.createElement(PaymentHistoryButton, null))));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceActions/InvoiceActions.tsx




const renderActions = ({ mode, draftProps, finalisedProps }) => {
  switch (mode) {
    case "DRAFT":
      return /* @__PURE__ */ react.createElement(DraftActions, {
        ...draftProps
      });
    case "FINALISED":
      return /* @__PURE__ */ react.createElement(FinalisedActions, {
        ...finalisedProps
      });
    default:
      return /* @__PURE__ */ react.createElement(DraftActions, {
        ...draftProps
      });
  }
};
const InvoiceActions = ({
  deleteInvoice,
  printInvoice,
  takePayment,
  voidInvoice,
  finaliseInvoice,
  refundInvoice,
  paymentHistory,
  displayOptions
}) => {
  const draftProps = {
    draftStatus: (displayOptions == null ? void 0 : displayOptions.status) || DraftStatus.EMPTY,
    deleteInvoice,
    printInvoice,
    finaliseInvoice
  };
  const finalisedProps = {
    finalisedStatus: (displayOptions == null ? void 0 : displayOptions.status) || FinalisedStatus.UNPAID,
    printInvoice,
    refundInvoice,
    voidInvoice,
    takePayment,
    paymentHistory
  };
  return renderActions({
    mode: (displayOptions == null ? void 0 : displayOptions.mode) || InvoiceMode.DRAFT,
    draftProps,
    finalisedProps
  });
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceActions/index.ts




/***/ }),

/***/ 79784:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": () => (/* binding */ InvoiceCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.8.36/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(4548);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Accordion/Accordion.js
var Accordion = __webpack_require__(74150);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(92473);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(41706);
// EXTERNAL MODULE: ./src/client/utils/useQuerystring.ts
var useQuerystring = __webpack_require__(19894);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(90898);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var mui_button_dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/ConditionalDisplay/index.ts + 1 modules
var ConditionalDisplay = __webpack_require__(7195);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceFilters/types.ts
var types = __webpack_require__(49361);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-chip@0.1.9_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-chip/dist/module.js
var mui_chip_dist_module = __webpack_require__(85810);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceSummary/InvoiceStatusChip.tsx



const statusMap = {
  DRAFT: {
    color: "primary",
    label: { id: "invoicing.invoice.summary.draft", defaultMessage: "Draft" }
  },
  UNPAID: {
    color: "warning",
    label: { id: "invoicing.invoice.summary.unpaid", defaultMessage: "Unpaid" }
  },
  PAID: {
    color: "success",
    label: { id: "invoicing.invoice.summary.paid", defaultMessage: "Paid" }
  },
  PARTIALLY_PAID: {
    color: "warning",
    label: {
      id: "invoicing.invoice.summary.partiallyPaid",
      defaultMessage: "Partially Paid"
    }
  },
  VOID: {
    color: "black",
    label: { id: "invoicing.invoice.summary.void", defaultMessage: "Void" }
  },
  REFUNDED: {
    color: "black",
    label: {
      id: "invoicing.invoice.summary.refunded",
      defaultMessage: "Refunded"
    }
  },
  PARTIALLY_REFUNDED: {
    color: "black",
    label: {
      id: "invoicing.invoice.summary.partiallyRefunded",
      defaultMessage: "Partially Refunded"
    }
  }
};
const InvoiceStatusChip = ({ status }) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  if (!status)
    return null;
  return /* @__PURE__ */ react.createElement(mui_chip_dist_module/* Chip */.A, {
    label: formatMessage(statusMap[status].label),
    color: statusMap[status].color
  });
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceSummary/InvoiceSummary.tsx









const useStyles = (0,dist_module/* makeStyles */.Z)({
  expandIcon: {
    transform: ({ expanded }) => expanded ? "rotate(0deg)" : "rotate(180deg)",
    transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
  },
  capitalize: {
    textTransform: "capitalize"
  }
});
const InvoiceSummary = ({
  expanded,
  setExpanded,
  invoiceNumber,
  invoiceStatus,
  created,
  creator,
  patientType,
  balance,
  total,
  payers,
  facility,
  organisation
}) => {
  const classes = useStyles({ expanded });
  const { formatDate, formatMessage } = (0,useIntl/* default */.Z)();
  const expandButtonLabel = expanded ? formatMessage({
    id: "invoicing.invoice.show-summary-view",
    defaultMessage: "Hide Invoice Details"
  }) : formatMessage({
    id: "invoicing.invoice.show-detail-view",
    defaultMessage: "Show Invoice Details"
  });
  const toggleExpanded = () => setExpanded(!expanded);
  const hasPatientPayer = !!payers.find(
    (p) => p.type === "PATIENT" && p.balance.paid > 0
  );
  let displayStatus = invoiceStatus;
  if (invoiceStatus === types/* InvoiceStatus.PartiallyPaid */.U.PartiallyPaid && !hasPatientPayer) {
    displayStatus = types/* InvoiceStatus.Unpaid */.U.Unpaid;
  }
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    justifyContent: "space-between",
    alignItems: "center",
    onClick: toggleExpanded
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 8
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h6"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.summary.invoiceNumber",
    defaultMessage: "Invoice {invoiceNumber}",
    values: { invoiceNumber }
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: true
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    textAlign: "right",
    mr: 1
  }, /* @__PURE__ */ react.createElement(InvoiceStatusChip, {
    status: displayStatus
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* IconButton */.hU, {
    onClick: toggleExpanded,
    "aria-label": expandButtonLabel
  }, /* @__PURE__ */ react.createElement(ExpandMore/* default */.Z, {
    className: classes.expandIcon
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 8
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "inline-block",
    mb: "8px"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.summary.facilityName",
    defaultMessage: "Facility: {facilityName}",
    values: { facilityName: facility.name }
  })), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.summary.organisationName",
    defaultMessage: "Organisation: {organisationName}",
    values: { organisationName: organisation.name }
  })))), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !expanded
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 7
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, /* @__PURE__ */ react.createElement("b", null, patientType)), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !!created
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "inline-block",
    mr: 2
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.summary.created",
    defaultMessage: "Invoiced on {created}",
    values: {
      created: formatDate(new Date(created), {
        day: "2-digit",
        month: "short",
        year: "numeric"
      })
    }
  }))), /* @__PURE__ */ react.createElement("span", {
    className: classes.capitalize
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.summary.creator",
    defaultMessage: "By: {creator}",
    values: { creator }
  })))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 5
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    textAlign: "right"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h6"
  }, /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: invoiceStatus === "DRAFT"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.summary.total",
    defaultMessage: "Total: {total}",
    values: { total }
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: invoiceStatus !== "DRAFT"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.summary.balance",
    defaultMessage: "Balance: {balance}",
    values: { balance }
  })))))));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceSummary/index.ts


// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(77589);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(32333);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(77572);
// EXTERNAL MODULE: ./src/client/components/ErrorPage/index.tsx
var ErrorPage = __webpack_require__(64493);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/hooks/useCurrencyFormatter.ts
var useCurrencyFormatter = __webpack_require__(69775);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/HelpOutline.js
var HelpOutline = __webpack_require__(73801);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(11313);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var mui_toast_dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(mui_toast_dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.7.2/node_modules/prop-types/index.js
var prop_types = __webpack_require__(19036);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(5427);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-to-print@2.12.6_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/react-to-print/lib/index.js
var react_to_print_lib = __webpack_require__(64300);
var lib_default = /*#__PURE__*/__webpack_require__.n(react_to_print_lib);
// EXTERNAL MODULE: ./src/client/services/dayjs.js
var dayjs = __webpack_require__(15063);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PrintableInvoice/Header.jsx





const Header_useStyles = (0,makeStyles/* default */.Z)(() => ({
  h1: {
    fontSize: 14,
    marginBottom: 5
  },
  h2: {
    fontSize: 14,
    marginBottom: 5
  },
  container: {
    display: "flex",
    justifyContent: "space-between"
  }
}));
const Header = ({ invoice }) => {
  const {
    invoiceNumber,
    patientType = "Outpatient",
    facility,
    created
  } = invoice;
  const classes = Header_useStyles();
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.container
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.h1
  }, /* @__PURE__ */ react.createElement("strong", null, facility.name)), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    flexDirection: "column"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.h2
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.invoiceNumber",
    defaultMessage: "Invoice no.:",
    values: { patientType }
  })), ` ${invoiceNumber}`), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.h2
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.invoicedOn",
    defaultMessage: "Invoiced on:"
  })), ` ${(0,dayjs/* default */.Z)(new Date(created)).format("DD/MM/YYYY")}`))), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.h2
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.invoiceType",
    defaultMessage: `{patientType, select,
            Outpatient {Outpatient}
            Inpatient {Inpatient}
            other {Unknown}
          } Invoice`,
    values: { patientType }
  })));
};
Header.propTypes = {
  invoice: prop_types_default().shape({
    invoiceNumber: (prop_types_default()).string,
    patientType: (prop_types_default()).string,
    created: (prop_types_default()).string,
    facility: prop_types_default().shape({
      name: (prop_types_default()).string
    })
  }).isRequired
};
/* harmony default export */ const PrintableInvoice_Header = (Header);

// EXTERNAL MODULE: ./src/client/utils/constants.ts
var constants = __webpack_require__(20589);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PrintableInvoice/PatientDetails.jsx






function isInpatient(type = "outpatient") {
  return type.toUpperCase() === constants/* INPATIENT_TYPE.toUpperCase */.ov.toUpperCase();
}
const PatientDetails_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  paragraph: {
    fontSize: 14,
    marginBottom: theme.spacing(0.5)
  },
  paragraphTitle: {
    fontSize: 16,
    marginBottom: theme.spacing(2)
  }
}));
const PatientDetails = ({ invoice }) => {
  var _a;
  const { patientType, inpatientDetails, patient } = invoice;
  const {
    person: { name: { firstname, lastname }, dob }
  } = patient;
  const classes = PatientDetails_useStyles();
  const { admission, inpatientNumber, discharge, ward } = inpatientDetails || {};
  const dobFormatted = (0,dayjs/* default */.Z)(dob).format("DD/MM/YYYY");
  const admissionDateFormatted = (0,dayjs/* default */.Z)(new Date(admission)).format(
    "DD/MM/YYYY"
  );
  const dischargeDateFormatted = (0,dayjs/* default */.Z)(new Date(discharge)).format(
    "DD/MM/YYYY"
  );
  const cardId = patient.cardId || ((_a = patient == null ? void 0 : patient.passport) == null ? void 0 : _a.uid);
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mt: 2,
    mb: 2
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.paragraphTitle
  }, /* @__PURE__ */ react.createElement("strong", null, `${firstname} ${lastname}`)), cardId && /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.paragraph
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.patient.id",
    defaultMessage: "Patient ID:"
  })), ` ${cardId}`), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.paragraph
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.patient.dob",
    defaultMessage: "D.O.B:"
  })), ` ${dobFormatted}`), isInpatient(patientType) && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.paragraph
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.patient.inpatient.number",
    defaultMessage: "Inpatient no.:"
  })), ` ${inpatientNumber != null ? inpatientNumber : "N/a"}`), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.paragraph
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.patient.inpatient.ward",
    defaultMessage: "Ward:"
  })), ` ${ward != null ? ward : "N/a"}`), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.paragraph
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.patient.inpatient.admissionDate",
    defaultMessage: "Date admitted:"
  })), ` ${admissionDateFormatted}`), discharge ? /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.paragraph
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.patient.inpatient.dischargeDate",
    defaultMessage: "Date discharged:"
  })), ` ${dischargeDateFormatted}`) : null));
};
PatientDetails.propTypes = {
  invoice: prop_types_default().shape({
    _id: (prop_types_default()).string.isRequired,
    patientType: (prop_types_default()).string.isRequired,
    invoiceStatus: (prop_types_default()).string.isRequired,
    patient: prop_types_default().shape({
      person: prop_types_default().shape({
        name: prop_types_default().shape({
          firstname: (prop_types_default()).string,
          lastname: (prop_types_default()).string
        }),
        dob: (prop_types_default()).string
      }),
      cardId: (prop_types_default()).string,
      passport: (prop_types_default()).string
    }).isRequired,
    inpatientDetails: prop_types_default().shape({}).isRequired
  }).isRequired
};
/* harmony default export */ const PrintableInvoice_PatientDetails = (PatientDetails);

// EXTERNAL MODULE: ./src/types/index.ts + 12 modules
var src_types = __webpack_require__(12823);
// EXTERNAL MODULE: ./src/client/billing/BillingProvider.tsx + 1 modules
var BillingProvider = __webpack_require__(78768);
// EXTERNAL MODULE: ./src/client/utils/useCurrencyFormat.ts
var useCurrencyFormat = __webpack_require__(13856);
// EXTERNAL MODULE: ./src/client/utils/useConvertCurrency.js
var useConvertCurrency = __webpack_require__(59807);
// EXTERNAL MODULE: ./src/__generated__/base.gql.ts
var base_gql = __webpack_require__(3047);
// EXTERNAL MODULE: ./src/style/images/elephant-invoice-icon.svg
var elephant_invoice_icon = __webpack_require__(11712);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PrintableInvoice/InvoicePrintSummary.jsx










const InvoicePrintSummary_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  container: {
    margin: `${theme.spacing(1)}px 0`,
    padding: `${theme.spacing(1)}px 0`,
    float: "right",
    width: "180px"
  },
  total: {
    textAlign: "right",
    fontSize: "14px",
    justifyContent: "flex-end",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  totalLarge: {
    textAlign: "right",
    fontSize: "14px",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(1)
  },
  logoContainer: {
    position: "absolute",
    bottom: 0,
    left: "calc(50% - 30px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "60px",
    textAlign: "center",
    alignContent: "flex-start",
    marginTop: theme.spacing(2)
  },
  logoMsg: {
    fontSize: 10,
    width: "60px"
  },
  logo: {
    width: "100%"
  },
  cell: {
    width: "50%",
    display: "inline-block",
    textAlign: "right"
  }
}));
function getRebateTotal({ admission, discharge, dailyRebateAmount }) {
  const numberOfDays = dayjs_min_default()(discharge).diff(dayjs_min_default()(admission), "day", true);
  return dailyRebateAmount * numberOfDays;
}
const InvoicePrintSummary = ({
  invoice: {
    balance,
    payers,
    transactions,
    invoiceStatus,
    patientType,
    inpatientDetails
  }
}) => {
  var _a;
  const classes = InvoicePrintSummary_useStyles();
  const penceToPounds = (0,useConvertCurrency/* useConvertFromPenceFactory */.YQ)();
  const currencyDetails = (0,BillingProvider/* useBillingCurrency */.eZ)();
  const currencyFormatter = (0,useCurrencyFormat/* default */.Z)(currencyDetails);
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const unpaid = invoiceStatus === "DRAFT" || invoiceStatus === "UNPAID" || invoiceStatus === "PARTIALLY_PAID";
  const includeRebateAmount = payers.find((p) => p.name === "NHIF") && patientType === "Inpatient" && inpatientDetails.dailyRebateAmount && inpatientDetails.admission && inpatientDetails.discharge;
  const totalWaived = (_a = transactions == null ? void 0 : transactions.filter((t) => t.payer.type === base_gql/* TransactionType.Waiver */.iU.Waiver).reduce((prevVal, curr) => prevVal + curr.amount.value, 0)) != null ? _a : 0;
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.logoContainer
  }, /* @__PURE__ */ react.createElement("img", {
    src: elephant_invoice_icon,
    alt: formatMessage({
      id: "printableInvoice.summary.logo",
      defaultMessage: "Elephant OS"
    }),
    className: classes.logo
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.logoMsg,
    type: "body2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.summary.logo.text",
    defaultMessage: "Elephant OS"
  }))), /* @__PURE__ */ react.createElement("div", {
    className: classes.container
  }, /* @__PURE__ */ react.createElement("div", {
    className: classes.cell
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.total
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.summary.outstandingBalance",
    defaultMessage: "Total:"
  })))), /* @__PURE__ */ react.createElement("div", {
    className: classes.cell
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.total
  }, /* @__PURE__ */ react.createElement("strong", null, `${currencyFormatter == null ? void 0 : currencyFormatter.format(
    penceToPounds(balance.total)
  )}`))), payers.map((payer) => {
    var _a2;
    return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", {
      className: classes.cell
    }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
      className: classes.totalLarge,
      key: payer.type
    }, payer.name === "PATIENT" ? "Patient" : ((_a2 = payer.insuranceDetails) == null ? void 0 : _a2.name) || payer.name, ":")), /* @__PURE__ */ react.createElement("div", {
      className: classes.cell
    }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
      className: classes.totalLarge,
      key: payer.type
    }, currencyFormatter == null ? void 0 : currencyFormatter.format(
      penceToPounds(
        unpaid ? payer.balance.total : payer.balance.paid
      )
    ))));
  }), totalWaived ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", {
    className: classes.cell
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.totalLarge
  }, "Waived:")), /* @__PURE__ */ react.createElement("div", {
    className: classes.cell
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.totalLarge
  }, currencyFormatter == null ? void 0 : currencyFormatter.format(penceToPounds(totalWaived))))) : void 0, includeRebateAmount && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", {
    className: classes.cell
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.totalLarge
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.summary.rebate",
    defaultMessage: "Rebate:"
  }))), /* @__PURE__ */ react.createElement("div", {
    className: classes.cell
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.totalLarge
  }, currencyFormatter == null ? void 0 : currencyFormatter.format(getRebateTotal(inpatientDetails)))))));
};
InvoicePrintSummary.propTypes = {
  balance: prop_types_default().shape({
    paid: (prop_types_default()).number,
    due: (prop_types_default()).number,
    total: (prop_types_default()).number,
    currency: (prop_types_default()).string
  }).isRequired,
  payers: prop_types_default().arrayOf(
    prop_types_default().shape({
      name: (prop_types_default()).string,
      type: (prop_types_default()).string,
      balance: prop_types_default().shape({
        paid: (prop_types_default()).number,
        due: (prop_types_default()).number,
        total: (prop_types_default()).number,
        currency: (prop_types_default()).string
      })
    })
  ).isRequired,
  invoiceStatus: (prop_types_default()).string.isRequired
};
/* harmony default export */ const PrintableInvoice_InvoicePrintSummary = (InvoicePrintSummary);

// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.2.6/node_modules/classnames/index.js
var classnames = __webpack_require__(97754);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PrintableInvoice/InvoicePrintItems.jsx








const InvoicePrintItems_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  root: {
    fontSize: 11,
    borderCollapse: "collapse",
    width: "100%",
    "& td, & th": {
      padding: "4px 0",
      "&:not(:last-child)": {
        paddingRight: theme.spacing(1)
      }
    }
  },
  textLeft: {
    textAlign: "left",
    fontSize: 12
  },
  textRight: {
    textAlign: "right",
    fontSize: 12
  },
  headerLabel: {
    fontSize: 12,
    color: theme.palette.grey.paragraph
  },
  itemDivider: {
    borderBottom: `1px solid ${theme.palette.grey.borderLight}`
  },
  header: {
    borderBottom: `1px solid ${theme.palette.grey.borderLight}`
  }
}));
const InvoiceItem = ({ item }) => {
  const {
    quantity,
    cost,
    priceListItem: { name, priceListItemType }
  } = item;
  const classes = InvoicePrintItems_useStyles();
  const penceToPounds = (0,useConvertCurrency/* useConvertFromPenceFactory */.YQ)();
  return /* @__PURE__ */ react.createElement("tr", {
    className: classnames_default()(classes.row, classes.itemDivider)
  }, /* @__PURE__ */ react.createElement("td", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.textLeft
  }, `${priceListItemType} - ${name}`)), /* @__PURE__ */ react.createElement("td", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.textRight
  }, quantity)), /* @__PURE__ */ react.createElement("td", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.textRight
  }, penceToPounds(cost))));
};
const InvoicePrintItems = ({ lineItems }) => {
  const classes = InvoicePrintItems_useStyles();
  const currencyDetails = (0,BillingProvider/* useBillingCurrency */.eZ)();
  const currency = (0,useCurrencyFormat/* default */.Z)(currencyDetails);
  const formattedCurrency = currency == null ? void 0 : currency.formatToParts(currency)[0].value;
  return /* @__PURE__ */ react.createElement("table", {
    className: classes.root
  }, /* @__PURE__ */ react.createElement("thead", {
    className: classes.header
  }, /* @__PURE__ */ react.createElement("tr", null, /* @__PURE__ */ react.createElement("th", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classnames_default()(classes.textLeft, classes.headerLabel)
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.lineItem.item",
    defaultMessage: "ITEM"
  })))), /* @__PURE__ */ react.createElement("th", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classnames_default()(classes.textRight, classes.headerLabel)
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.lineItem.quantity",
    defaultMessage: "QTY"
  })))), /* @__PURE__ */ react.createElement("th", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classnames_default()(classes.textRight, classes.headerLabel)
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.lineItem.price",
    defaultMessage: "PRICE"
  }), formattedCurrency && ` (${formattedCurrency})`))))), /* @__PURE__ */ react.createElement("tbody", null, lineItems.map((lineItem) => /* @__PURE__ */ react.createElement(InvoiceItem, {
    key: lineItem._id,
    item: lineItem
  }))));
};
InvoiceItem.propTypes = {
  item: prop_types_default().shape({
    quantity: (prop_types_default()).number,
    cost: (prop_types_default()).number,
    priceListItem: prop_types_default().shape({
      name: (prop_types_default()).string,
      priceListItemType: (prop_types_default()).string
    })
  }).isRequired
};
InvoicePrintItems.propTypes = {
  lineItems: prop_types_default().arrayOf(
    prop_types_default().shape({
      _id: (prop_types_default()).string
    })
  ).isRequired
};
/* harmony default export */ const PrintableInvoice_InvoicePrintItems = (InvoicePrintItems);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PrintableInvoice/InvoiceTable.jsx





const InvoiceTable = ({ invoice }) => {
  const enabledLineItems = invoice.lineItems.filter(
    (lineItem) => !lineItem.disabled
  );
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mb: 1,
    display: "flex",
    flexDirection: "column",
    width: "100%"
  }, /* @__PURE__ */ react.createElement(PrintableInvoice_InvoicePrintItems, {
    lineItems: enabledLineItems
  }), /* @__PURE__ */ react.createElement(PrintableInvoice_InvoicePrintSummary, {
    invoice
  }));
};
InvoiceTable.propTypes = {
  invoice: src_types/* InvoiceType.isRequired */.us.isRequired
};
/* harmony default export */ const PrintableInvoice_InvoiceTable = (InvoiceTable);

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InsurerAccordion/formConstants.ts
var formConstants = __webpack_require__(18946);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/utils.ts

const getPrintableInvoices = (invoicesToPrint, payers) => {
  if ((payers == null ? void 0 : payers.length) === 1 && payers.filter((p) => p.type === formConstants/* INSURER */.lj)) {
    return payers.filter((p) => p.type === formConstants/* INSURER */.lj);
  }
  if ((invoicesToPrint == null ? void 0 : invoicesToPrint.length) > 0) {
    return payers.filter(
      (p) => {
        var _a;
        return invoicesToPrint.includes(((_a = p == null ? void 0 : p.insuranceDetails) == null ? void 0 : _a.name) || p.name);
      }
    );
  }
  return payers;
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/formConstants.ts
const LINEITEMS = "lineItems";
const PRICE_LIST_ITEM = "priceListItem";
const QUANTITY = "quantity";
const FORMATTED_PRICE = "formattedPrice";
const COST = "cost";
const WARD = "ward";
const INPATIENT_NUMBER = "inpatientNumber";
const ADMISSION_DATE = "admission";
const DISCHARGE_DATE = "discharge";
const PATIENT_TYPE = "patientType";
const OUTPATIENT = "Outpatient";
const INPATIENT = "Inpatient";
const INPATIENT_DETAILS = "inpatientDetails";
const DISABLED = "disabled";
const REVENUE_DEPARTMENT = "revenueDepartment";
const PRICE_TARIFF = "activeTariffId";

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PrintableInvoice/InsuranceHeader.jsx






const InsuranceHeader_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  facility: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: theme.spacing(1)
  },
  insurer: {
    fontSize: 20,
    fontWeight: 700
  },
  label: {
    fontSize: 12,
    fontWeight: 700
  },
  facilityInfo: {
    fontSize: 12
  },
  invoiceInfo: {
    borderBottom: `1px solid ${theme.palette.grey.borderLight}`,
    display: "flex",
    flexDirection: "row",
    margin: `${theme.spacing(3)}px 0`
  },
  wrapper: {
    display: "inline-block",
    width: "70%",
    verticalAlign: "top"
  },
  insurerWrapper: {
    display: "inline-block",
    verticalAlign: "top",
    width: "30%",
    textAlign: "right"
  },
  paragraph: {
    fontSize: 14,
    padding: `${theme.spacing(0.5)}px 0`
  },
  invoiceContainer: {
    display: "flex",
    flexDirection: "column",
    padding: `${theme.spacing(0.5)}px 0`
  },
  invoiceType: {
    fontSize: 16,
    fontWeight: 700,
    marginRight: theme.spacing(1)
  },
  invoiceNumber: {
    fontSize: 18,
    fontWeight: 700
  },
  outpatient: {
    fontSize: 14,
    display: "flex",
    marginTop: theme.spacing(1)
  },
  visitDate: {
    fontSize: 14,
    display: "flex",
    marginBottom: theme.spacing(2)
  }
}));
const HeaderTitle = ({ insurer }) => {
  var _a;
  if (insurer.name === formConstants/* NHIF */.ev) {
    return "NHIF";
  }
  return insurer.name === formConstants/* LINDA_MAMA_ID */.$L ? "Linda Mama" : ((_a = insurer == null ? void 0 : insurer.insuranceDetails) == null ? void 0 : _a.name) || insurer.name;
};
const InsuranceHeader = ({ insurer, invoice }) => {
  var _a, _b;
  const { invoiceNumber, patientType = "Outpatient", facility } = invoice;
  const classes = InsuranceHeader_useStyles();
  const address = (_b = (_a = facility == null ? void 0 : facility.addresses) == null ? void 0 : _a[0]) != null ? _b : {};
  const street = (address == null ? void 0 : address.street) ? `${address == null ? void 0 : address.street}, ` : "";
  const ward = (address == null ? void 0 : address.ward) ? address == null ? void 0 : address.ward : "";
  const subCounty = (address == null ? void 0 : address.subCounty) ? ` ${address == null ? void 0 : address.subCounty}, ` : "";
  const formattedAddress = street + ward + subCounty + (address == null ? void 0 : address.state);
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.wrapper
  }, /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.facility
  }, facility == null ? void 0 : facility.name)), /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement("span", {
    className: classes.label
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.insurer.address",
    defaultMessage: "Address:"
  })), /* @__PURE__ */ react.createElement("span", {
    className: classes.facilityInfo
  }, formattedAddress))), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.insurerWrapper
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.insurer
  }, /* @__PURE__ */ react.createElement(HeaderTitle, {
    insurer
  })))), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.invoiceInfo
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.invoiceType
  }, patientType === OUTPATIENT ? "OUTPATIENT" : "INPATIENT"), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.invoiceType
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.insurer.invoice",
    defaultMessage: "INVOICE"
  })), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.invoiceNumber
  }, ` ${invoiceNumber}`)));
};
InsuranceHeader.propTypes = {
  invoice: prop_types_default().shape({
    invoiceNumber: (prop_types_default()).string,
    created: (prop_types_default()).string,
    patientType: (prop_types_default()).string,
    inpatientDetails: prop_types_default().shape({
      inpatientNumber: (prop_types_default()).string,
      admission: (prop_types_default()).string,
      discharge: (prop_types_default()).string
    })
  }).isRequired,
  insurer: prop_types_default().shape({
    name: (prop_types_default()).string
  }).isRequired
};
/* harmony default export */ const PrintableInvoice_InsuranceHeader = (InsuranceHeader);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PrintableInvoice/InsuranceDetails.jsx








const DATE_FORMAT = "DD/MM/YYYY";
const InsuranceDetails_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  insurer: {
    marginBottom: theme.spacing(1),
    paddingBottom: theme.spacing(2)
  },
  patient: {
    width: "100%",
    display: "flex",
    flexDirection: "column"
  },
  names: {
    fontSize: 16
  },
  container: {
    display: "flex",
    justifyContent: "space-between"
  },
  facility: {
    marginLeft: theme.spacing(2)
  },
  label: {
    fontSize: 12,
    marginTop: theme.spacing(1)
  },
  listItem: {
    display: "flex",
    fontSize: 14
  },
  row: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between"
  },
  column: {
    display: "flex",
    flexDirection: "column",
    width: "33.333%"
  }
}));
function getInpatientDates(inpatientDetails = {}) {
  const { admission, discharge } = inpatientDetails;
  if (admission && discharge) {
    return `${(0,dayjs/* default */.Z)(admission).format(DATE_FORMAT)}-${(0,dayjs/* default */.Z)(discharge).format(
      DATE_FORMAT
    )}`;
  }
  return "-";
}
const InsuranceDetails = ({ insurer, invoice }) => {
  var _a;
  const { patient, createdBy } = invoice;
  const insuranceDetails = insurer == null ? void 0 : insurer.insuranceDetails;
  const {
    person: { name: { firstname, lastname, middlename } }
  } = patient;
  const { person } = createdBy;
  const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1).toLowerCase();
  const classes = InsuranceDetails_useStyles();
  const dependency = (insuranceDetails == null ? void 0 : insuranceDetails.dependent) || (insuranceDetails == null ? void 0 : insuranceDetails.dependency) || "";
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.insurer
  }, /* @__PURE__ */ react.createElement(PrintableInvoice_InsuranceHeader, {
    insurer,
    invoice
  }), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.container
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.patient
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.names
  }, /* @__PURE__ */ react.createElement("strong", null, `${firstname} ${middlename || ""} ${lastname}`)), /* @__PURE__ */ react.createElement(Box/* default */.Z, null, invoice.inpatientDetails && /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.label
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.patient.inpatientNumber",
    defaultMessage: "Inpatient Number:"
  })), ` ${(_a = invoice.inpatientDetails) == null ? void 0 : _a.inpatientNumber}`)), /* @__PURE__ */ react.createElement("div", {
    className: classes.row
  }, /* @__PURE__ */ react.createElement("div", {
    className: classes.column
  }, dependency && /* @__PURE__ */ react.createElement("div", {
    className: classes.cell
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.label
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.patient.dependency",
    defaultMessage: "Dependant:"
  })), ` ${capitalize(dependency.replace(/dependent/i, ""))}`)), (insuranceDetails == null ? void 0 : insuranceDetails.membershipNumber) || (insuranceDetails == null ? void 0 : insuranceDetails.insuranceNumber) && /* @__PURE__ */ react.createElement("div", {
    className: classes.cell
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.label
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.patient.membershipNumber",
    defaultMessage: "Membership No:"
  })), ` ${(insuranceDetails == null ? void 0 : insuranceDetails.membershipNumber) || (insuranceDetails == null ? void 0 : insuranceDetails.insuranceNumber)}`))), /* @__PURE__ */ react.createElement("div", {
    className: classes.column
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement("div", {
    className: classnames_default()(classes.cell, classes.textRight)
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.label
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.insurer.visitType",
    defaultMessage: "Visit type:"
  })), invoice.patientType === INPATIENT ? /* @__PURE__ */ react.createElement(react.Fragment, null, " ", /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.insurer.visitType.inpatient",
    defaultMessage: "Inpatient"
  })) : /* @__PURE__ */ react.createElement(react.Fragment, null, " ", /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.insurer.visitType.outpatient",
    defaultMessage: "General"
  }))))), /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement("div", {
    className: classnames_default()(classes.cell, classes.textRight)
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.label
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.insurer.visitDate",
    defaultMessage: "Visit date:"
  })), invoice.patientType === INPATIENT ? ` ${getInpatientDates(invoice.inpatientDetails)}` : ` ${(0,dayjs/* default */.Z)(new Date(invoice.created)).format(
    DATE_FORMAT
  )}`)))), /* @__PURE__ */ react.createElement("div", {
    className: classes.column
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement("div", {
    className: classnames_default()(classes.cell, classes.textRight)
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.label
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.insurer.invoicedOn",
    defaultMessage: "Invoiced on:"
  })), ` ${(0,dayjs/* default */.Z)(new Date(invoice.created)).format(DATE_FORMAT)}`))), /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement("div", {
    className: classnames_default()(classes.cell, classes.textRight)
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.label
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "printableInvoice.insurer.preparedBy",
    defaultMessage: "Prepared by:"
  })), ` ${person == null ? void 0 : person.firstname} ${person == null ? void 0 : person.lastname}`))))))));
};
InsuranceDetails.propTypes = {
  insurer: prop_types_default().shape({
    insuranceDetails: prop_types_default().shape({
      membershipNumber: (prop_types_default()).string
    })
  }).isRequired,
  invoice: prop_types_default().shape({
    patient: prop_types_default().shape({
      insurance: prop_types_default().shape({
        insuranceDetails: prop_types_default().shape({
          dependency: (prop_types_default()).string,
          insuranceNumber: (prop_types_default()).string
        })
      }),
      person: prop_types_default().shape({
        name: prop_types_default().shape({
          firstname: (prop_types_default()).string,
          lastname: (prop_types_default()).string
        })
      })
    }),
    facility: prop_types_default().shape({
      name: (prop_types_default()).string.isRequired,
      addresses: prop_types_default().arrayOf(
        prop_types_default().shape({
          street: (prop_types_default()).string,
          ward: (prop_types_default()).string,
          subCounty: (prop_types_default()).string,
          state: (prop_types_default()).string
        })
      )
    }).isRequired
  }).isRequired
};
/* harmony default export */ const PrintableInvoice_InsuranceDetails = (InsuranceDetails);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PrintableInvoice/InsurerInvoice.jsx









const InsurerInvoice_useStyles = (0,makeStyles/* default */.Z)({
  printWrapper: {
    margin: "5mm"
  },
  box: {
    margin: "0",
    position: "relative",
    height: "94%"
  }
});
const InsurerInvoice = ({ invoice, insurer }) => {
  const classes = InsurerInvoice_useStyles();
  return /* @__PURE__ */ react.createElement("div", {
    className: classes.printWrapper,
    key: insurer.name
  }, /* @__PURE__ */ react.createElement("div", {
    style: { pageBreakBefore: "always" }
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.box
  }, (insurer == null ? void 0 : insurer.type) === formConstants/* INSURER */.lj ? /* @__PURE__ */ react.createElement(PrintableInvoice_InsuranceDetails, {
    insurer,
    invoice
  }) : /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(PrintableInvoice_Header, {
    invoice
  }), /* @__PURE__ */ react.createElement(PrintableInvoice_PatientDetails, {
    invoice
  })), /* @__PURE__ */ react.createElement(PrintableInvoice_InvoiceTable, {
    insurer,
    invoice
  }))));
};
InsurerInvoice.propTypes = {
  invoice: src_types/* InvoiceType.isRequired */.us.isRequired,
  insurer: prop_types_default().shape({
    name: (prop_types_default()).string,
    type: (prop_types_default()).string
  }).isRequired
};
/* harmony default export */ const PrintableInvoice_InsurerInvoice = (InsurerInvoice);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PrintableInvoice/PrintableInvoice.jsx









const PrintableInvoice_useStyles = (0,makeStyles/* default */.Z)({
  containerWrapper: {
    display: "none"
  },
  printWrapper: {
    margin: "5mm"
  },
  box: {
    margin: "0 15px"
  }
});
class ComponentToPrint extends react.Component {
  render() {
    const { classes = {}, invoice, invoicesToPrint } = this.props;
    if (!invoice) {
      return null;
    }
    const invoicesToBePrinted = getPrintableInvoices(
      invoicesToPrint,
      invoice == null ? void 0 : invoice.payers
    );
    if ((invoicesToBePrinted == null ? void 0 : invoicesToBePrinted.length) > 0) {
      return /* @__PURE__ */ react.createElement("div", null, invoicesToBePrinted.map((insurerInvoice) => /* @__PURE__ */ react.createElement(PrintableInvoice_InsurerInvoice, {
        key: insurerInvoice._id,
        invoice,
        insurer: insurerInvoice
      })));
    }
    return /* @__PURE__ */ react.createElement("div", {
      className: classes.printWrapper
    }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      className: classes.box
    }, /* @__PURE__ */ react.createElement(PrintableInvoice_Header, {
      invoice
    }), /* @__PURE__ */ react.createElement(PrintableInvoice_PatientDetails, {
      invoice
    }), /* @__PURE__ */ react.createElement(PrintableInvoice_InvoiceTable, {
      invoice
    })));
  }
}
ComponentToPrint.propTypes = {
  classes: prop_types_default().shape({}).isRequired,
  invoice: prop_types_default().shape({
    payers: prop_types_default().arrayOf(prop_types_default().shape({}))
  }).isRequired,
  invoicesToPrint: prop_types_default().arrayOf((prop_types_default()).string).isRequired
};
class ReactToPrintRemoteTrigger extends (lib_default()) {
  render() {
    return /* @__PURE__ */ react.createElement("div", null);
  }
}
const PrintableInvoice = (props) => {
  const componentRef = (0,react.useRef)();
  const invoiceRef = (0,react.useRef)();
  const classes = PrintableInvoice_useStyles();
  const { onAfterPrint } = props;
  (0,react.useEffect)(() => {
    invoiceRef.current.handleClick();
  }, []);
  return /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(ReactToPrintRemoteTrigger, {
    ref: invoiceRef,
    content: () => componentRef.current,
    pageStyle: "@page{ size: a4; } @media print{  }",
    onAfterPrint
  }), /* @__PURE__ */ react.createElement("div", {
    className: classes.containerWrapper
  }, /* @__PURE__ */ react.createElement(ComponentToPrint, {
    ref: componentRef,
    classes,
    ...props
  })));
};
PrintableInvoice.propTypes = {
  onAfterPrint: (prop_types_default()).func.isRequired,
  invoice: prop_types_default().shape({}).isRequired,
  invoicesToPrint: prop_types_default().arrayOf((prop_types_default()).string).isRequired
};
/* harmony default export */ const PrintableInvoice_PrintableInvoice = (PrintableInvoice);

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/useFetchPrintableInvoice.tsx + 1 modules
var useFetchPrintableInvoice = __webpack_require__(47921);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PrintableInvoice.tsx





const ERROR_MESSAGE = (0,lib/* defineMessage */.Em)({
  id: "invoicing.getInvoice.error.msg",
  defaultMessage: "Failed to fetch this invoice"
});
const InvoiceDetails_PrintableInvoice_PrintableInvoice = ({
  invoiceId,
  payerNames,
  onAfterPrint
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { data, loading, error } = (0,useFetchPrintableInvoice/* default */.Z)(invoiceId, {
    fetchPolicy: "network-only"
  });
  if (loading) {
    return null;
  }
  if (error) {
    dist_default().error(formatMessage(ERROR_MESSAGE));
    onAfterPrint();
    return null;
  }
  return /* @__PURE__ */ react.createElement(PrintableInvoice_PrintableInvoice, {
    invoice: data.invoice,
    invoicesToPrint: payerNames,
    onAfterPrint
  });
};

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/PrintPayerSelectionModal.tsx
var PrintPayerSelectionModal = __webpack_require__(32132);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/modals/index.ts + 17 modules
var modals = __webpack_require__(45052);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/EditSwitch/index.ts + 1 modules
var EditSwitch = __webpack_require__(59457);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/usePrintThermalReceipt.tsx
var usePrintThermalReceipt = __webpack_require__(23218);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/hooks/usePermissions.ts
var usePermissions = __webpack_require__(14344);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceFilters/index.ts + 2 modules
var InvoiceFilters = __webpack_require__(38617);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/useFetchInvoice.tsx + 1 modules
var useFetchInvoice = __webpack_require__(86492);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceActions/index.ts + 4 modules
var InvoiceActions = __webpack_require__(90848);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/getDisplayOptions.ts


const getDisplayOptions = (invoice) => {
  var _a;
  const isNotFinalised = (invoice == null ? void 0 : invoice.invoiceStatus) === types/* InvoiceStatus.Draft */.U.Draft;
  const isEmpty = ((_a = invoice == null ? void 0 : invoice.lineItems) == null ? void 0 : _a.length) < 1;
  const isPaid = (invoice == null ? void 0 : invoice.invoiceStatus) === types/* InvoiceStatus.Paid */.U.Paid;
  const isPartiallyPaid = (invoice == null ? void 0 : invoice.invoiceStatus) === types/* InvoiceStatus.PartiallyPaid */.U.PartiallyPaid && (invoice == null ? void 0 : invoice.hasPatientPayer);
  const isUnpaid = (invoice == null ? void 0 : invoice.invoiceStatus) === types/* InvoiceStatus.Unpaid */.U.Unpaid || (invoice == null ? void 0 : invoice.invoiceStatus) === types/* InvoiceStatus.PartiallyPaid */.U.PartiallyPaid && !(invoice == null ? void 0 : invoice.hasPatientPayer);
  const isRefunded = (invoice == null ? void 0 : invoice.invoiceStatus) === types/* InvoiceStatus.Refunded */.U.Refunded;
  const isVoid = (invoice == null ? void 0 : invoice.invoiceStatus) === types/* InvoiceStatus.Void */.U.Void;
  const isPartiallyRefunded = (invoice == null ? void 0 : invoice.invoiceStatus) === types/* InvoiceStatus.PartiallyRefunded */.U.PartiallyRefunded;
  let mode;
  if (isNotFinalised) {
    const draftMode = { mode: InvoiceActions/* InvoiceMode.DRAFT */.m0.DRAFT, status: "" };
    if (isEmpty) {
      draftMode.status = InvoiceActions/* DraftStatus.EMPTY */.FV.EMPTY;
    } else {
      draftMode.status = InvoiceActions/* DraftStatus.POPULATED */.FV.POPULATED;
    }
    mode = draftMode;
  } else {
    const finalisedMode = { mode: InvoiceActions/* InvoiceMode.FINALISED */.m0.FINALISED, status: "" };
    if (isPaid) {
      finalisedMode.status = InvoiceActions/* FinalisedStatus.PAID */.M8.PAID;
    } else if (isRefunded) {
      finalisedMode.status = InvoiceActions/* FinalisedStatus.REFUNDED */.M8.REFUNDED;
    } else if (isVoid) {
      finalisedMode.status = InvoiceActions/* FinalisedStatus.VOID */.M8.VOID;
    } else if (isPartiallyRefunded) {
      finalisedMode.status = InvoiceActions/* FinalisedStatus.PARTIALLY_REFUNDED */.M8.PARTIALLY_REFUNDED;
    } else if (isPartiallyPaid) {
      finalisedMode.status = InvoiceActions/* FinalisedStatus.PARTIALLY_PAID */.M8.PARTIALLY_PAID;
    } else if (isUnpaid) {
      finalisedMode.status = InvoiceActions/* FinalisedStatus.UNPAID */.M8.UNPAID;
    }
    mode = finalisedMode;
  }
  return mode;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/TableContainer/TableContainer.js
var TableContainer = __webpack_require__(13153);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Table/Table.js
var Table = __webpack_require__(13510);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/TableHead/TableHead.js
var TableHead = __webpack_require__(45722);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/TableRow/TableRow.js
var TableRow = __webpack_require__(56858);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/TableCell/TableCell.js
var TableCell = __webpack_require__(63550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/TableBody/TableBody.js
var TableBody = __webpack_require__(82842);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Add.js
var Add = __webpack_require__(91136);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Save.js
var Save = __webpack_require__(4217);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.31.1/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(1793);
// EXTERNAL MODULE: ./src/client/forms/hookForm/index.ts
var hookForm = __webpack_require__(86347);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/useUpdateLineItems.ts
var useUpdateLineItems = __webpack_require__(51952);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/types.ts
var InvoiceCard_types = __webpack_require__(89856);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/InvoiceLineItemColor.tsx



const InvoiceLineItemColor_useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  root: {
    width: theme.spacing(0.5),
    marginRight: theme.spacing(1),
    borderRadius: "2px",
    background: ({ type }) => {
      switch (type) {
        case InvoiceCard_types/* PriceListItemType.PROCEDURE */.Q.PROCEDURE:
          return theme.palette.procedures.main;
        case InvoiceCard_types/* PriceListItemType.PRESCRIPTION */.Q.PRESCRIPTION:
          return theme.palette.figma.pink.dark;
        case InvoiceCard_types/* PriceListItemType.INVESTIGATION */.Q.INVESTIGATION:
          return theme.palette.figma.blue.dark;
        case InvoiceCard_types/* PriceListItemType.CONSULTATION */.Q.CONSULTATION:
          return theme.palette.figma.primary.dark;
        case InvoiceCard_types/* PriceListItemType.OTHER */.Q.OTHER:
          return theme.palette.figma.purple.dark;
        default:
          return theme.palette.figma.purple.dark;
      }
    },
    display: "inline-block",
    height: "100%"
  }
}));
const InvoiceLineItemColor = ({ type }) => {
  const classes = InvoiceLineItemColor_useStyles({ type });
  return /* @__PURE__ */ react.createElement("span", {
    className: classes.root,
    "data-testid": "invoicing.lineItem.color"
  }, "\xA0");
};

// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.16.1/node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(13875);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/InvoiceLineItem.tsx







const InvoiceLineItem_useStyles = (0,dist_module/* makeStyles */.Z)(() => ({
  disabledCell: {
    opacity: 0.5,
    pointerEvents: "none"
  }
}));
const InvoiceLineItem = ({
  quantity,
  priceListItem,
  formattedPrice,
  automated,
  disabled,
  incurredAt
}) => {
  const classes = InvoiceLineItem_useStyles();
  const { name, priceListItemType } = priceListItem;
  const priceListV2Enabled = (0,featureFlags/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.billing.usePriceListV2 */.VH.billing.usePriceListV2
  );
  return /* @__PURE__ */ react.createElement(TableRow/* default */.Z, {
    className: classnames_default()({ [classes.disabledCell]: automated && disabled })
  }, /* @__PURE__ */ react.createElement(TableCell/* default */.Z, null, incurredAt ? /* @__PURE__ */ react.createElement("span", {
    title: incurredAt.toString()
  }, (0,format/* default */.Z)(incurredAt, "yyyy-MM-dd")) : null), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, null, /* @__PURE__ */ react.createElement(InvoiceLineItemColor, {
    type: priceListItemType
  }), name), priceListV2Enabled && /* @__PURE__ */ react.createElement(TableCell/* default */.Z, null, priceListItem == null ? void 0 : priceListItem.revenueDepartment), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, null, quantity), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, null, formattedPrice)));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Delete.js
var Delete = __webpack_require__(7056);
// EXTERNAL MODULE: ./src/client/forms/hookForm/fields/index.ts
var fields = __webpack_require__(95674);
// EXTERNAL MODULE: ./src/client/forms/inputs/TextField.tsx
var TextField = __webpack_require__(78802);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PriceListItemInput.tsx




const PriceListItemInput = ({
  name,
  priceListItems = [],
  disabled = false
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const itemNotFound = formatMessage({
    id: "invoicing.lineItems.pricelist.itemNotFound",
    defaultMessage: "Item not found"
  });
  const label = formatMessage({
    id: "invoicing.lineItems.pricelist.label",
    defaultMessage: "Item"
  });
  return /* @__PURE__ */ react.createElement(fields/* RHFAutocomplete */.Fl, {
    disabled,
    name,
    options: priceListItems,
    noOptionsText: itemNotFound,
    getOptionLabel: (option) => option.name,
    getOptionSelected: (option, value) => option.uuid === value.uuid,
    fullWidth: true,
    disableClearable: true,
    renderInput: (errStr) => (params) => {
      return /* @__PURE__ */ react.createElement(TextField/* default */.Z, {
        ...params,
        name,
        required: true,
        label,
        error: errStr,
        inputProps: {
          ...params.inputProps
        }
      });
    }
  });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(68261);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PriceTypeInput.tsx






const PriceTypeInput = ({
  selectedPayer,
  quantity,
  index
}) => {
  var _a;
  const { currencyFormatter } = (0,useCurrencyFormatter/* default */.Z)();
  const { setValue } = (0,index_esm/* useFormContext */.Gc)();
  const cost = (selectedPayer == null ? void 0 : selectedPayer.amountInPence) * quantity;
  const displayPrice = selectedPayer ? currencyFormatter(selectedPayer.amountInPence * quantity) : "-";
  const displayName = (0,capitalize/* default */.Z)((_a = selectedPayer == null ? void 0 : selectedPayer.name) != null ? _a : "-");
  (0,react.useEffect)(() => {
    setValue(`${LINEITEMS}[${index}].${FORMATTED_PRICE}`, displayPrice);
    setValue(`${LINEITEMS}[${index}].${COST}`, cost);
  }, [displayPrice, index, setValue, cost]);
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    p: 1
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, null, /* @__PURE__ */ react.createElement("strong", null, displayPrice)), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, displayName));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/EditableInvoiceLineItem.tsx











const EditableInvoiceLineItem_useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  priceListItem: {
    width: "40%"
  },
  quantity: {
    width: "20%"
  },
  row: {
    "& td": {
      padding: theme.spacing(2, 2, 0, 2),
      verticalAlign: "top"
    }
  },
  actions: {
    alignSelf: "center"
  }
}));
const EditableInvoiceLineItem = ({
  removeItem,
  lineItem,
  index,
  priceList
}) => {
  var _a, _b, _c, _d, _e, _f;
  const classes = EditableInvoiceLineItem_useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const isAnAutomatedLineItem = lineItem.automated;
  const quantity = (_a = (0,index_esm/* useWatch */.qo)({ name: `${LINEITEMS}[${index}].${QUANTITY}` })) != null ? _a : lineItem == null ? void 0 : lineItem.quantity;
  const selectedPriceListItem = (_c = (_b = (0,index_esm/* useWatch */.qo)({ name: `${LINEITEMS}[${index}].${PRICE_LIST_ITEM}` })) != null ? _b : lineItem == null ? void 0 : lineItem.priceListItem) != null ? _c : {};
  const selectedItemPayers = (_f = (_e = (_d = priceList == null ? void 0 : priceList.priceListItems) == null ? void 0 : _d.filter(
    (price) => price.uuid === (selectedPriceListItem == null ? void 0 : selectedPriceListItem.uuid)
  )[0]) == null ? void 0 : _e.payers) != null ? _f : [];
  const selectedPayer = selectedItemPayers == null ? void 0 : selectedItemPayers[0];
  return /* @__PURE__ */ react.createElement(TableRow/* default */.Z, {
    className: classes.row
  }, /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.priceListItem
  }, /* @__PURE__ */ react.createElement(PriceListItemInput, {
    name: `${LINEITEMS}[${index}].${PRICE_LIST_ITEM}`,
    priceListItems: priceList.priceListItems || [],
    disabled: isAnAutomatedLineItem
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.quantity
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
    name: `${LINEITEMS}[${index}].${QUANTITY}`,
    type: "number",
    required: true,
    fullWidth: true,
    InputProps: { inputProps: { min: 1, max: 1e3 } },
    label: formatMessage({
      id: "invoicing.quantity.label",
      defaultMessage: "Qty"
    }),
    disabled: isAnAutomatedLineItem
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(PriceTypeInput, {
    selectedPayer,
    index,
    quantity
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: true,
    className: classes.actions
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    pl: 2,
    textAlign: "right"
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* IconButton */.hU, {
    color: "error",
    onClick: () => removeItem(index),
    "aria-label": formatMessage({
      id: "invoicing.lineItems.delete",
      defaultMessage: "Remove item"
    })
  }, /* @__PURE__ */ react.createElement(Delete/* default */.Z, null)))))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.9/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(85961);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/formHelpers.ts

const useValidationSchema = () => {
  return (0,es.object)({
    lineItems: (0,es.array)().of(
      (0,es.object)({
        automated: (0,es.boolean)(),
        id: (0,es.string)(),
        quantity: (0,es.number)().min(1).required(),
        priceListItem: (0,es.object)().shape({
          uuid: (0,es.string)().when("automated", {
            is: true,
            then: (schema) => schema.required(),
            otherwise: (schema) => schema.nullable(true)
          }),
          revenueDepartment: (0,es.string)().when("automated", {
            is: true,
            then: (0,es.string)().required(),
            otherwise: (0,es.string)().nullable()
          }),
          activeTariffId: (0,es.string)().when("automated", {
            is: true,
            then: (0,es.string)().required(),
            otherwise: (0,es.string)().nullable()
          })
        }).required()
      })
    )
  });
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/LineItemSection.tsx
















const LineItemSection_useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  header: {
    fontWeight: 700,
    fontSize: 12,
    color: theme.palette.grey.gray600,
    fontFamily: theme.typography.fontFamily,
    textTransform: "uppercase"
  }
}));
const defaultValues = { lineItems: [] };
const LineItemSection = ({
  invoiceId,
  invoice,
  priceList,
  editable,
  hasLineItems,
  setHasLineItems,
  total,
  setTotal,
  dispatcher,
  busy
}) => {
  const classes = LineItemSection_useStyles();
  const [newItemCount, setNewItemCount] = (0,react.useState)(0);
  const { updateLineItems, saving } = (0,useUpdateLineItems/* default */.Z)(invoiceId);
  const lineItemFormMethods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    reValidateMode: "onChange",
    resolver: (0,yup/* yupResolver */.X)(useValidationSchema()),
    defaultValues
  });
  const {
    control,
    reset: resetFormState,
    formState,
    trigger: triggerValidation,
    setValue,
    reset
  } = lineItemFormMethods;
  const watchedInvoiceLineItems = (0,index_esm/* useWatch */.qo)({
    name: LINEITEMS,
    defaultValue: [],
    control
  });
  const { fields, append, remove } = (0,index_esm/* useFieldArray */.Dq)({
    control,
    name: LINEITEMS
  });
  const { isDirty } = formState;
  (0,react.useEffect)(() => {
    if ((invoice == null ? void 0 : invoice.lineItems) && invoice.lineItems.length > 0) {
      setValue(LINEITEMS, invoice.lineItems);
      resetFormState(invoice);
    }
  }, [invoice, resetFormState, setValue]);
  (0,react.useEffect)(() => {
    const currHasLineItems = watchedInvoiceLineItems.length > 0;
    if (currHasLineItems !== hasLineItems) {
      setHasLineItems(currHasLineItems);
    }
  }, [watchedInvoiceLineItems, setHasLineItems, hasLineItems]);
  const totalCost = watchedInvoiceLineItems.filter((l) => !l.disabled).reduce(
    (a, b) => a + (b.cost && !Number.isNaN(b.cost) ? b.cost : 0),
    0
  );
  (0,react.useEffect)(() => {
    if (totalCost !== total) {
      setTotal(totalCost);
    }
  }, [totalCost, setTotal, total]);
  const saveItems = async (formValues) => {
    dispatcher.sendBusy();
    try {
      await updateLineItems(formValues == null ? void 0 : formValues.lineItems);
      reset(formValues);
    } finally {
      dispatcher.sendBusy(false);
    }
  };
  const removeItem = (index) => {
    remove(index);
  };
  const addNewItem = async () => {
    append({
      id: "",
      tempId: newItemCount,
      formattedPrice: "",
      quantity: 1,
      priceListItem: {
        name: "",
        uuid: "",
        priceListItemType: ""
      }
    });
    await triggerValidation();
    setNewItemCount(newItemCount + 1);
  };
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...lineItemFormMethods
  }, /* @__PURE__ */ react.createElement("form", {
    name: "lineItemsForms",
    onSubmit: lineItemFormMethods.handleSubmit(saveItems)
  }, /* @__PURE__ */ react.createElement(TableContainer/* default */.Z, null, /* @__PURE__ */ react.createElement(Table/* default */.Z, null, /* @__PURE__ */ react.createElement(TableHead/* default */.Z, null, /* @__PURE__ */ react.createElement(TableRow/* default */.Z, null, /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.header.item",
    defaultMessage: "Item"
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.header.quantity",
    defaultMessage: "Qty"
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.header.price",
    defaultMessage: "Price"
  })))), /* @__PURE__ */ react.createElement(TableBody/* default */.Z, null, fields == null ? void 0 : fields.map((lineItem, index) => {
    if (editable)
      return /* @__PURE__ */ react.createElement(EditableInvoiceLineItem, {
        key: `${invoiceId}-${lineItem.tempId || lineItem.id}`,
        lineItem,
        index,
        removeItem,
        priceList
      });
    return /* @__PURE__ */ react.createElement(InvoiceLineItem, {
      key: `${invoiceId}-${lineItem.tempId || lineItem.id}`,
      ...lineItem
    });
  })))), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !hasLineItems
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    p: 2,
    textAlign: "center"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle1"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.empty.title",
    defaultMessage: "No items"
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !editable
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.empty.subtitle",
    defaultMessage: "Enable editing to add items"
  }))))), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: editable
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    py: 2
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: addNewItem,
    startIcon: /* @__PURE__ */ react.createElement(Add/* default */.Z, null),
    "data-testid": "invoicing.addItem.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.addItem",
    defaultMessage: "Add Item"
  })))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    py: 2,
    textAlign: "right"
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFSubmitButton */.Qz, {
    color: "secondary",
    type: "submit",
    disabled: !isDirty || busy,
    loading: saving,
    startIcon: /* @__PURE__ */ react.createElement(Save/* default */.Z, null),
    "data-testid": "invoicing.saveItems.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.saveItems",
    defaultMessage: "Save line items"
  }))))))))));
};

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/useUpdateLineItemsV2.ts
var useUpdateLineItemsV2 = __webpack_require__(7915);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/EnableSwitch/EnableSwitch.tsx
var EnableSwitch = __webpack_require__(96224);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var graphql_tag_lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+react-hook-form-input@0.1.7_sjfm3rrfwwtsx5okgtvvldeidu/node_modules/@elephant-healthcare/react-hook-form-input/dist/module.js
var react_hook_form_input_dist_module = __webpack_require__(29054);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/RevenueDepartmentSelectInput.tsx



const QUERY = graphql_tag_lib/* gql */.Ps`
  query revenueDepartments {
    priceListV2 {
      revenueDepartments {
        edges {
          id
          name
        }
      }
    }
  }
`;
const RevenueDepartmentSelectInput = ({
  name
}) => {
  var _a;
  const { data: revDepts } = (0,useQuery/* useQuery */.a)(QUERY);
  const revenueDepartmentsOptions = (_a = revDepts == null ? void 0 : revDepts.priceListV2.revenueDepartments.edges.map((revDep) => ({
    value: revDep.name,
    label: revDep.name
  }))) != null ? _a : [];
  return /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* SelectField */.mg, {
    name,
    options: revenueDepartmentsOptions,
    fullWidth: true,
    hideHelper: true
  });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(64432);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-input@0.3.5_atek3e5pugfjeukz7kzynbm6iy/node_modules/@elephant-healthcare/mui-input/dist/module.js
var mui_input_dist_module = __webpack_require__(34948);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/TariffSelectInput.tsx





const TariffSelectInput_useStyles = (0,makeStyles/* default */.Z)({
  selectField: {
    margin: 0,
    paddingTop: 0
  },
  tariffName: {
    fontSize: "12px",
    margin: 0
  },
  listItem: {
    display: "block"
  }
});
const TariffSelectInput = ({
  name,
  selectedTariff,
  payers
}) => {
  const classes = TariffSelectInput_useStyles();
  const { currencyFormatter } = (0,useCurrencyFormatter/* default */.Z)();
  const { setValue } = (0,index_esm/* useFormContext */.Gc)();
  (0,react.useEffect)(() => {
    setValue(name, selectedTariff);
  }, [name, selectedTariff, setValue]);
  return /* @__PURE__ */ react.createElement(mui_input_dist_module/* SelectField */.mg, {
    name,
    fullWidth: true,
    hideHelper: true,
    selectProps: {
      value: selectedTariff,
      className: classes.selectField,
      onChange: (e) => {
        setValue(name, e.target.value, { shouldDirty: true });
      }
    }
  }, payers == null ? void 0 : payers.map((payer) => /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    key: payer.tariffId,
    value: payer.tariffId,
    className: classes.listItem
  }, currencyFormatter(payer.amountInPence), /* @__PURE__ */ react.createElement("p", {
    className: classes.tariffName
  }, payer.name))));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/EditableInvoiceLineItemV2.tsx















const EditableInvoiceLineItemV2_useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  priceListItem: {
    width: "40%"
  },
  quantity: {
    width: "20%"
  },
  row: {
    "& td": {
      padding: theme.spacing(2, 2, 0, 2),
      verticalAlign: "top"
    }
  },
  actions: {
    alignSelf: "center"
  },
  disabledCell: {
    opacity: 0.5,
    pointerEvents: "none"
  }
}));
const EditableInvoiceLineItemV2 = ({
  removeItem,
  lineItem,
  index,
  priceList
}) => {
  var _a, _b, _c;
  const classes = EditableInvoiceLineItemV2_useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { setValue } = (0,index_esm/* useFormContext */.Gc)();
  const isAnAutomatedLineItem = lineItem.automated;
  const [enabled, setEnabled] = (0,react.useState)(
    !isAnAutomatedLineItem || isAnAutomatedLineItem && !lineItem.disabled
  );
  (0,react.useEffect)(() => {
    setValue(`${LINEITEMS}[${index}].${DISABLED}`, !enabled, {
      shouldDirty: true
    });
  }, [enabled, setValue, index]);
  const selectedPriceListItem = (_b = (_a = (0,index_esm/* useWatch */.qo)({ name: `${LINEITEMS}[${index}].${PRICE_LIST_ITEM}` })) != null ? _a : lineItem == null ? void 0 : lineItem.priceListItem) != null ? _b : {};
  const selectedItemPayers = selectedPriceListItem == null ? void 0 : selectedPriceListItem.payers;
  const selectedPayer = (_c = selectedItemPayers == null ? void 0 : selectedItemPayers.find(
    (payer) => payer.tariffId === selectedPriceListItem.activeTariffId
  )) != null ? _c : selectedItemPayers == null ? void 0 : selectedItemPayers[0];
  return /* @__PURE__ */ react.createElement(TableRow/* default */.Z, {
    className: classes.row
  }, /* @__PURE__ */ react.createElement(TableCell/* default */.Z, null, lineItem.incurredAt ? /* @__PURE__ */ react.createElement("span", {
    title: lineItem.incurredAt.toString()
  }, (0,format/* default */.Z)(lineItem.incurredAt, "yyyy-MM-dd")) : null), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classnames_default()(classes.priceListItem, {
      [classes.disabledCell]: !enabled
    })
  }, /* @__PURE__ */ react.createElement(PriceListItemInput, {
    name: `${LINEITEMS}[${index}].${PRICE_LIST_ITEM}`,
    priceListItems: priceList.priceListItems || [],
    disabled: isAnAutomatedLineItem
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classnames_default()(classes.priceListItem, {
      [classes.disabledCell]: !enabled
    })
  }, /* @__PURE__ */ react.createElement(RevenueDepartmentSelectInput, {
    name: `${LINEITEMS}[${index}].${PRICE_LIST_ITEM}.${REVENUE_DEPARTMENT}`
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classnames_default()(classes.quantity, {
      [classes.disabledCell]: !enabled || isAnAutomatedLineItem
    })
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
    name: `${LINEITEMS}[${index}].${QUANTITY}`,
    type: "number",
    required: true,
    fullWidth: true,
    InputProps: {
      inputProps: { min: 1, max: 1e3 },
      "data-testid": `${LINEITEMS}[${index}].${QUANTITY}`
    },
    label: formatMessage({
      id: "invoicing.quantity.label",
      defaultMessage: "Qty"
    }),
    disabled: isAnAutomatedLineItem
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    className: classnames_default()({ [classes.disabledCell]: !enabled })
  }, /* @__PURE__ */ react.createElement(TariffSelectInput, {
    name: `${LINEITEMS}[${index}].${PRICE_LIST_ITEM}.${PRICE_TARIFF}`,
    selectedTariff: selectedPayer == null ? void 0 : selectedPayer.tariffId,
    payers: selectedItemPayers
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: true,
    className: classes.actions
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    pl: 2,
    textAlign: "right"
  }, isAnAutomatedLineItem ? /* @__PURE__ */ react.createElement(EnableSwitch/* EnableSwitch */.V, {
    enabled,
    setEnabled
  }) : /* @__PURE__ */ react.createElement(mui_button_dist_module/* IconButton */.hU, {
    color: "error",
    onClick: () => removeItem(index),
    "aria-label": formatMessage({
      id: "invoicing.lineItems.delete",
      defaultMessage: "Remove item"
    })
  }, /* @__PURE__ */ react.createElement(Delete/* default */.Z, null)))))));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/LineItemSectionV2.tsx
















const LineItemSectionV2_useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  header: {
    fontWeight: 700,
    fontSize: 12,
    color: theme.palette.grey.gray600,
    fontFamily: theme.typography.fontFamily,
    textTransform: "uppercase"
  }
}));
const LineItemSectionV2 = ({
  invoiceId,
  invoice,
  priceList,
  editable,
  hasLineItems,
  setHasLineItems,
  total,
  setTotal,
  dispatcher,
  busy
}) => {
  const classes = LineItemSectionV2_useStyles();
  const [newItemCount, setNewItemCount] = (0,react.useState)(0);
  const { updateLineItems, saving } = (0,useUpdateLineItemsV2/* default */.Z)(invoiceId);
  const lineItemFormMethods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    reValidateMode: "onChange",
    resolver: (0,yup/* yupResolver */.X)(useValidationSchema()),
    defaultValues: { lineItems: [] }
  });
  const {
    control,
    reset: resetFormState,
    formState,
    trigger: triggerValidation,
    setValue
  } = lineItemFormMethods;
  const watchedInvoiceLineItems = (0,index_esm/* useWatch */.qo)({
    name: LINEITEMS,
    defaultValue: [],
    control
  });
  const { fields, append, remove } = (0,index_esm/* useFieldArray */.Dq)({
    control,
    name: LINEITEMS
  });
  const { isDirty } = formState;
  (0,react.useEffect)(() => {
    if ((invoice == null ? void 0 : invoice.lineItems) && invoice.lineItems.length > 0) {
      setValue(LINEITEMS, invoice.lineItems);
      resetFormState(invoice);
    }
  }, [invoice, resetFormState, setValue]);
  (0,react.useEffect)(() => {
    const currHasLineItems = watchedInvoiceLineItems.length > 0;
    if (currHasLineItems !== hasLineItems) {
      setHasLineItems(currHasLineItems);
    }
  }, [watchedInvoiceLineItems, setHasLineItems, hasLineItems]);
  const totalCost = watchedInvoiceLineItems.filter((l) => !l.disabled).reduce(
    (a, b) => a + (b.cost && !Number.isNaN(b.cost) ? b.cost : 0),
    0
  );
  (0,react.useEffect)(() => {
    if (totalCost !== total) {
      setTotal(totalCost);
    }
  }, [totalCost, setTotal, total]);
  const saveItems = async (formValues) => {
    dispatcher.sendBusy();
    try {
      await updateLineItems(formValues == null ? void 0 : formValues.lineItems);
      resetFormState(formValues);
    } finally {
      dispatcher.sendBusy(false);
    }
  };
  const removeItem = (index) => {
    remove(index);
  };
  const addNewItem = async () => {
    append({
      id: "",
      tempId: newItemCount,
      formattedPrice: "",
      quantity: 1,
      priceListItem: {
        name: "",
        uuid: "",
        priceListItemType: "",
        externalReference: {
          origin: "",
          foreignId: ""
        },
        activeTariffId: null,
        revenueDepartment: null
      },
      automated: false,
      disabled: false
    });
    await triggerValidation();
    setNewItemCount(newItemCount + 1);
  };
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...lineItemFormMethods
  }, /* @__PURE__ */ react.createElement("form", {
    name: "lineItemsForms",
    onSubmit: lineItemFormMethods.handleSubmit(saveItems)
  }, /* @__PURE__ */ react.createElement(TableContainer/* default */.Z, null, /* @__PURE__ */ react.createElement(Table/* default */.Z, null, /* @__PURE__ */ react.createElement(TableHead/* default */.Z, null, /* @__PURE__ */ react.createElement(TableRow/* default */.Z, null, /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.header.date",
    defaultMessage: "Date"
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.header.item",
    defaultMessage: "Item"
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.header.revenueDepartment",
    defaultMessage: "Revenue Dpt"
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.header.quantity",
    defaultMessage: "Qty"
  })), /* @__PURE__ */ react.createElement(TableCell/* default */.Z, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.header.price",
    defaultMessage: "Price"
  })))), /* @__PURE__ */ react.createElement(TableBody/* default */.Z, null, fields == null ? void 0 : fields.map((lineItem, index) => {
    if (editable)
      return /* @__PURE__ */ react.createElement(EditableInvoiceLineItemV2, {
        key: `${invoiceId}-${lineItem.tempId || lineItem.id}`,
        lineItem,
        index,
        removeItem,
        priceList
      });
    return /* @__PURE__ */ react.createElement(InvoiceLineItem, {
      key: `${invoiceId}-${lineItem.tempId || lineItem.id}`,
      ...lineItem
    });
  })))), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !hasLineItems
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    p: 2,
    textAlign: "center"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle1"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.empty.title",
    defaultMessage: "No items"
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !editable
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.empty.subtitle",
    defaultMessage: "Enable editing to add items"
  }))))), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: editable
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    py: 2
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: addNewItem,
    startIcon: /* @__PURE__ */ react.createElement(Add/* default */.Z, null),
    "data-testid": "invoicing.addItem.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.addItem",
    defaultMessage: "Add Item"
  })))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    py: 2,
    textAlign: "right"
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFSubmitButton */.Qz, {
    color: "secondary",
    type: "submit",
    disabled: !isDirty || busy,
    loading: saving,
    startIcon: /* @__PURE__ */ react.createElement(Save/* default */.Z, null),
    "data-testid": "invoicing.saveItems.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.lineItem.saveItems",
    defaultMessage: "Save line items"
  }))))))))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Menu/Menu.js
var Menu = __webpack_require__(99313);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/useUpdateInsurers.ts + 1 modules
var useUpdateInsurers = __webpack_require__(6764);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InsurerAccordion/formHelpers.ts
var formHelpers = __webpack_require__(55535);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InsurerAccordion/index.ts + 6 modules
var InsurerAccordion = __webpack_require__(59300);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/InsurerSection.tsx















const InsurerSection_useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  insurerContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  buttonContainer: {
    marginTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.grey.border}`
  },
  addInsurersButton: {
    marginTop: theme.spacing(1)
  },
  header: {
    fontWeight: 700,
    fontSize: 12,
    color: theme.palette.grey.gray600,
    fontFamily: theme.typography.fontFamily,
    textTransform: "uppercase"
  }
}));
const InsurerSection = ({
  canAddInsurers,
  hasLineItems,
  payers,
  totalAmount,
  invoiceId,
  patientInsurance,
  editable,
  insurers,
  paid,
  setPaid,
  isDraft,
  dispatcher,
  busy
}) => {
  const classes = InsurerSection_useStyles();
  const [anchorEl, setAnchorEl] = (0,react.useState)(null);
  const { currencyFormatter } = (0,useCurrencyFormatter/* default */.Z)();
  const insurersFormMethods = (0,index_esm/* useForm */.cI)({
    mode: "all",
    reValidateMode: "onSubmit",
    resolver: (0,yup/* yupResolver */.X)((0,formHelpers/* useValidationSchema */.e)(totalAmount)),
    defaultValues: { payers }
  });
  const { control, handleSubmit, formState, reset } = insurersFormMethods;
  const { isValid, isDirty } = formState;
  const { fields, append, remove } = (0,index_esm/* useFieldArray */.Dq)({
    control,
    name: formConstants/* INSURERS */.tT
  });
  const watchedInsurers = (0,index_esm/* useWatch */.qo)({ name: formConstants/* INSURERS */.tT, control });
  const availableInsurers = insurers.filter(
    (i) => !watchedInsurers.find(
      (p) => {
        var _a;
        return i.name === ((_a = p == null ? void 0 : p.insuranceDetails) == null ? void 0 : _a.name) || i.insuranceType === formConstants/* PRIVATE_INSURANCE */.hN && i.name === p.name;
      }
    )
  );
  const amountPaid = (0,react.useMemo)(() => {
    return watchedInsurers.reduce(
      (a, b) => {
        var _a;
        return a + ((_a = b == null ? void 0 : b.balance) == null ? void 0 : _a.total) || 0;
      },
      0
    );
  }, [watchedInsurers]);
  (0,react.useEffect)(() => {
    if (amountPaid !== paid) {
      setPaid(amountPaid);
    }
  }, [amountPaid, paid, setPaid]);
  const { updateInsurers } = (0,useUpdateInsurers/* default */.Z)(watchedInsurers, invoiceId);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleAddInsurer = (insurer) => {
    var _a, _b, _c, _d;
    const patientHasInsurance = insurer.insuranceType === (patientInsurance == null ? void 0 : patientInsurance.insuranceType);
    const insurerName = insurer.insuranceType !== formConstants/* PRIVATE_INSURANCE */.hN ? insurer.name : ((_a = patientInsurance == null ? void 0 : patientInsurance.insuranceDetails) == null ? void 0 : _a.schemeName) || null;
    handleClose();
    append({
      type: insurer.insuranceType,
      name: insurer.name,
      balance: {
        total: 0
      },
      properties: insurer.properties,
      insuranceDetails: {
        name: insurerName,
        insuranceNumber: patientHasInsurance ? (_b = patientInsurance == null ? void 0 : patientInsurance.insuranceDetails) == null ? void 0 : _b.insuranceNumber : null,
        dependent: patientHasInsurance && insurer.insuranceType !== formConstants/* PRIVATE_INSURANCE */.hN ? (_c = patientInsurance == null ? void 0 : patientInsurance.insuranceDetails) == null ? void 0 : _c.dependent : null,
        nationalIdNumber: patientHasInsurance ? (_d = patientInsurance == null ? void 0 : patientInsurance.insuranceDetails) == null ? void 0 : _d.nationalIdNumber : null
      }
    });
  };
  const handleRemoveInsurer = (index) => {
    remove(index);
  };
  const saveInsurers = async (formValues) => {
    dispatcher.sendBusy();
    try {
      await updateInsurers(formValues);
      reset(formValues);
    } finally {
      dispatcher.sendBusy(false);
    }
  };
  if (!hasLineItems)
    return null;
  return /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...insurersFormMethods
  }, /* @__PURE__ */ react.createElement("form", {
    name: "InsurersForm",
    onSubmit: handleSubmit(saveInsurers)
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    className: classes.insurerContainer
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h6"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.insuranceSection.title",
    defaultMessage: "Insurance"
  }))), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !editable
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    py: 2
  }, /* @__PURE__ */ react.createElement(Divider/* default */.Z, null)), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: watchedInsurers.length < 1
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    p: 2,
    textAlign: "center"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle1"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.insuranceSection.noInsurers.title",
    defaultMessage: "No insurance"
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: isDraft
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.insuranceSection.noInsurers.subtitle",
    defaultMessage: "Enable editing to add insurers"
  }))))), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: watchedInsurers.length > 0
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 8,
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    px: 2
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.insuranceSection.heading.insurer",
    defaultMessage: "Insurer"
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 4,
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    px: 2
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.insuranceSection.heading.Amount",
    defaultMessage: "Amount"
  }))), fields.map((insurer) => /* @__PURE__ */ react.createElement(react.Fragment, {
    key: `${insurer.name}-${insurer.balance.total}`
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 8
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    px: 2
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, null, insurer.name))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 4
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    px: 2
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, null, currencyFormatter(insurer.balance.total)))))))))), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: editable
  }, /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: availableInsurers.length > 0
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    className: classes.buttonContainer
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: handleClick,
    startIcon: /* @__PURE__ */ react.createElement(Add/* default */.Z, null),
    className: classes.addInsurersButton,
    disabled: !canAddInsurers
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.insurers.addInsurer",
    defaultMessage: "Add Insurer"
  })), /* @__PURE__ */ react.createElement(Menu/* default */.Z, {
    id: "invoicing-insurer-menu",
    anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, availableInsurers == null ? void 0 : availableInsurers.map((insurer) => /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    onClick: () => handleAddInsurer(insurer),
    key: insurer.id
  }, insurer.name))))), /* @__PURE__ */ react.createElement(Divider/* default */.Z, null), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: (fields == null ? void 0 : fields.length) > 0
  }, fields == null ? void 0 : fields.map((payer, index) => /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    key: payer == null ? void 0 : payer.name
  }, /* @__PURE__ */ react.createElement(InsurerAccordion/* default */.ZP, {
    index,
    insurer: payer,
    handleRemoveInsurer,
    insurers,
    invoiceId
  })))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    textAlign: "right"
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    type: "submit",
    color: "secondary",
    disabled: !isDirty || !isValid || busy,
    startIcon: /* @__PURE__ */ react.createElement(Save/* default */.Z, null),
    "data-testid": "invoicing.saveInsurers.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.saveInsurers",
    defaultMessage: "Save Insurers"
  }))))))));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/Receipt/LaserReceiptPrint/Header.jsx




const LaserReceiptPrint_Header_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  clinicSection: {
    fontFamily: theme.typography.fontBold,
    textTransform: "uppercase",
    textAlign: "center"
  },
  h1: {
    fontSize: 26
  },
  h2: {
    marginTop: theme.spacing(1),
    fontSize: 24
  }
}));
const Header_Header = ({ invoice }) => {
  const {
    patientType: type,
    facility: { name }
  } = invoice;
  const classes = LaserReceiptPrint_Header_useStyles();
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    mb: 2,
    className: classes.clinicSection
  }, /* @__PURE__ */ react.createElement("strong", {
    className: classes.h1
  }, name), /* @__PURE__ */ react.createElement("strong", {
    className: classes.h2
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoice.laserReceipt.heading",
    defaultMessage: "{type} payment receipt",
    values: { type }
  })));
};
Header_Header.propTypes = {
  invoice: prop_types_default().shape({
    patientType: (prop_types_default()).string,
    facility: prop_types_default().shape({
      name: (prop_types_default()).string
    })
  }).isRequired
};
/* harmony default export */ const LaserReceiptPrint_Header = (Header_Header);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/Receipt/LaserReceiptPrint/PatientDetails.jsx





const PatientDetails_PatientDetails = ({ patientDetails }) => {
  var _a, _b;
  const { firstname, lastname } = (_a = patientDetails == null ? void 0 : patientDetails.person) == null ? void 0 : _a.name;
  const cardId = patientDetails.cardId || ((_b = patientDetails == null ? void 0 : patientDetails.passport) == null ? void 0 : _b.uid);
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    flexDirection: "column",
    mb: 2
  }, /* @__PURE__ */ react.createElement("span", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoice.laserReceipt.patient.name",
    defaultMessage: "Patient name: {first} {last}",
    values: {
      first: firstname != null ? firstname : "",
      last: lastname != null ? lastname : ""
    }
  })), cardId && /* @__PURE__ */ react.createElement("span", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoice.laserReceipt.patient.id",
    defaultMessage: "Patient ID: {cardId}",
    values: {
      cardId
    }
  })));
};
PatientDetails_PatientDetails.propTypes = {
  patientDetails: src_types/* PatientDetailsType */.rT,
  cardId: (prop_types_default()).string.isRequired
};
PatientDetails_PatientDetails.defaultProps = {
  patientDetails: void 0
};
/* harmony default export */ const LaserReceiptPrint_PatientDetails = (PatientDetails_PatientDetails);

// EXTERNAL MODULE: ./src/client/utils/useFormatPence.js
var useFormatPence = __webpack_require__(42197);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/Receipt/LaserReceiptPrint/LineItems.jsx




const LineItems_useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  table: {
    fontSize: 14,
    width: "100%"
  },
  lineItemRoot: {
    marginBottom: theme.spacing(1)
  },
  lineItemCell: {
    paddingRight: theme.spacing(1)
  },
  lineItemPriceCell: {
    textAlign: "right"
  }
}));
const LineItems = ({ lineItems }) => {
  const classes = LineItems_useStyles();
  const formatPence = (0,useFormatPence/* useFormatPenceFactory */.c)();
  return /* @__PURE__ */ react.createElement("table", {
    className: classes.table
  }, /* @__PURE__ */ react.createElement("tbody", null, lineItems.map((lineItem) => /* @__PURE__ */ react.createElement("tr", {
    key: lineItem.id,
    className: classes.lineItemRoot
  }, /* @__PURE__ */ react.createElement("td", {
    className: classes.lineItemCell
  }, lineItem.priceListItem.name), /* @__PURE__ */ react.createElement("td", {
    className: classes.lineItemCell
  }, `x${lineItem.quantity}`), /* @__PURE__ */ react.createElement("td", {
    className: classes.lineItemPriceCell
  }, formatPence(lineItem.cost))))));
};
LineItems.propTypes = {
  lineItems: prop_types_default().arrayOf(
    prop_types_default().shape({
      id: (prop_types_default()).string,
      quantity: (prop_types_default()).number,
      priceListItem: prop_types_default().shape({
        name: (prop_types_default()).string
      })
    })
  ).isRequired
};
/* harmony default export */ const LaserReceiptPrint_LineItems = (LineItems);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/Receipt/LaserReceiptPrint/Paid.jsx






const Paid_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  paidSection: {
    marginBottom: theme.spacing(1),
    fontSize: 14,
    fontFamily: theme.typography.fontBold,
    width: "100%"
  }
}));
const Row = ({ name, amount }) => {
  const formatPence = (0,useFormatPence/* useFormatPenceFactory */.c)();
  let printName = name;
  if (name === "PATIENT") {
    printName = "Patient";
  }
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    justifyContent: "flex-end"
  }, /* @__PURE__ */ react.createElement("strong", null, `${printName}: `), formatPence(amount));
};
const Paid = ({ invoice }) => {
  const classes = Paid_useStyles();
  const formatPence = (0,useFormatPence/* useFormatPenceFactory */.c)();
  const exemptInvoice = invoice == null ? void 0 : invoice.transactions.filter(
    (t) => t.payer.type === "EXEMPT"
  );
  const totalWaived = invoice.transactions.filter((t) => t.payer.type === base_gql/* TransactionType.Waiver */.iU.Waiver).reduce((prevVal, curr) => prevVal + curr.amount.value, 0);
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    justifyContent: "space-between",
    className: classes.paidSection
  }, /* @__PURE__ */ react.createElement("span", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoice.laserReceipt.total",
    defaultMessage: "Total"
  })), /* @__PURE__ */ react.createElement("span", {
    className: classes.totalPaid
  }, formatPence(invoice.balance.total))), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mt: 2
  }, invoice.payers.map((p) => /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Row, {
    name: p.name,
    amount: p.balance.paid
  }), exemptInvoice.length > 0 && /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    justifyContent: "flex-end"
  }, /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "print.invoice.exempt",
    defaultMessage: "Exempt:"
  })), /* @__PURE__ */ react.createElement("span", {
    className: classes.totalPaid
  }, formatPence(invoice.balance.total))))), totalWaived ? /* @__PURE__ */ react.createElement(Row, {
    name: "Waived",
    amount: totalWaived
  }) : void 0));
};
Paid.propTypes = {
  invoice: src_types/* InvoiceType.isRequired */.us.isRequired
};
/* harmony default export */ const LaserReceiptPrint_Paid = (Paid);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/Receipt/LaserReceiptPrint/TransactionLines.jsx







const TransactionLines = ({ invoice }) => {
  const { created, transactions } = invoice;
  const timestampFormatted = (0,dayjs/* default */.Z)(created).format("DD/MM/YYYY HH:mm");
  const formatPence = (0,useFormatPence/* useFormatPenceFactory */.c)();
  const filteredTransactions = transactions.filter(
    (t) => t.payer.type !== "INSURER"
  );
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    my: 2
  }, filteredTransactions.length > 1 && /* @__PURE__ */ react.createElement("strong", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoice.laserReceipt.transaction.heading",
    defaultMessage: "{length} Transactions",
    values: { length: filteredTransactions.length }
  })), filteredTransactions.map((tx) => {
    var _a, _b, _c, _d, _e, _f;
    return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      mb: 2,
      key: tx._id
    }, (((_a = tx == null ? void 0 : tx.payment) == null ? void 0 : _a.authCode) || ((_b = tx == null ? void 0 : tx.refund) == null ? void 0 : _b.authCode)) && /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "invoice.laserReceipt.transaction.authCode",
      defaultMessage: "Safaricom code: {code}",
      values: { code: ((_c = tx == null ? void 0 : tx.payment) == null ? void 0 : _c.authCode) || ((_d = tx == null ? void 0 : tx.refund) == null ? void 0 : _d.authCode) }
    })), /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
      style: { textTransform: "capitalize", fontSize: "inherit" }
    }, tx.payer.type.toLowerCase(), ": ", /* @__PURE__ */ react.createElement("strong", null, formatPence(tx.amount.value)))), tx.actionedBy && /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "invoice.laserReceipt.transaction.servedBy",
      defaultMessage: "Served by: {name}",
      values: {
        name: `${(_e = tx.actionedBy.person.firstname) != null ? _e : ""} ${(_f = tx.actionedBy.person.lastname) != null ? _f : ""}`
      }
    })));
  }), /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoice.laserReceipt.transaction.date",
    defaultMessage: "On: {date}",
    values: {
      date: timestampFormatted
    }
  }));
};
TransactionLines.propTypes = {
  invoice: src_types/* InvoiceType.isRequired */.us.isRequired,
  transactions: prop_types_default().arrayOf(src_types/* TransactionType */.iU).isRequired
};
/* harmony default export */ const LaserReceiptPrint_TransactionLines = (TransactionLines);

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./src/client/utils/getLocationUrl.js
var getLocationUrl = __webpack_require__(89202);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PrintableInvoice/Footer.jsx




const Footer = () => /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
  mt: 2,
  mb: 1
}, /* @__PURE__ */ react.createElement(mui_icon_dist_module.LogoTextIcon, null)), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
  mb: 1
}, (0,getLocationUrl/* default */.Z)()));
/* harmony default export */ const PrintableInvoice_Footer = (Footer);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/Receipt/PatientLaserReceipt.jsx









const PatientLaserReceipt_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  containerWrapper: {
    display: "none"
  },
  printWrapper: {
    margin: "5mm"
  },
  box: {
    border: `1px solid ${theme.palette.grey.dark}`,
    padding: theme.spacing(2)
  },
  itemPriceDivider: {
    backgroundColor: theme.palette.text.primary,
    border: `2px solid ${theme.palette.text.primary}`,
    height: 0,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    width: "100%"
  },
  invoiceNumber: {
    fontFamily: theme.typography.fontBold
  }
}));
const PatientLaserReceipt = ({ invoice }) => {
  const classes = PatientLaserReceipt_useStyles();
  const { invoiceNumber } = invoice;
  const enabledLineItems = invoice.lineItems.filter(
    (lineItem) => !lineItem.disabled
  );
  return /* @__PURE__ */ react.createElement("div", {
    id: "printWrapper",
    className: classes.printWrapper
  }, /* @__PURE__ */ react.createElement("div", {
    style: { pageBreakBefore: "always" }
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    p: [2, 0],
    className: classes.box
  }, /* @__PURE__ */ react.createElement(LaserReceiptPrint_Header, {
    invoice
  }), /* @__PURE__ */ react.createElement(LaserReceiptPrint_PatientDetails, {
    patientDetails: invoice.patient
  }), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mb: 2,
    className: classes.invoiceNumber
  }, invoiceNumber), /* @__PURE__ */ react.createElement(LaserReceiptPrint_LineItems, {
    lineItems: enabledLineItems
  }), /* @__PURE__ */ react.createElement(Divider/* default */.Z, {
    className: classes.itemPriceDivider
  }), /* @__PURE__ */ react.createElement(LaserReceiptPrint_Paid, {
    invoice
  }), /* @__PURE__ */ react.createElement(LaserReceiptPrint_TransactionLines, {
    invoice
  }), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(PrintableInvoice_Footer, null)))));
};
PatientLaserReceipt.propTypes = {
  invoice: src_types/* InvoiceType.isRequired */.us.isRequired
};
/* harmony default export */ const Receipt_PatientLaserReceipt = (PatientLaserReceipt);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/Receipt/LaserReceiptPrint.jsx








const LaserReceiptPrint_useStyles = (0,dist_module/* makeStyles */.Z)({
  containerWrapper: {
    display: "none"
  }
});
class LaserReceiptPrint_ComponentToPrint extends react.Component {
  render() {
    const { invoice, invoicesToPrint, printReceiptOnly } = this.props;
    if (!invoice) {
      return null;
    }
    if (printReceiptOnly) {
      return /* @__PURE__ */ react.createElement(Receipt_PatientLaserReceipt, {
        invoice
      });
    }
    const invoicesToBePrinted = getPrintableInvoices(
      invoicesToPrint,
      invoice == null ? void 0 : invoice.payers
    );
    if ((invoicesToBePrinted == null ? void 0 : invoicesToBePrinted.length) > 0) {
      return /* @__PURE__ */ react.createElement("div", null, invoicesToBePrinted.map((insurerInvoice) => {
        if ((insurerInvoice == null ? void 0 : insurerInvoice.type) === formConstants/* INSURER */.lj) {
          return /* @__PURE__ */ react.createElement(PrintableInvoice_InsurerInvoice, {
            invoice,
            insurer: insurerInvoice,
            key: insurerInvoice == null ? void 0 : insurerInvoice.type
          });
        }
        return /* @__PURE__ */ react.createElement(Receipt_PatientLaserReceipt, {
          invoice,
          key: insurerInvoice == null ? void 0 : insurerInvoice.type
        });
      }));
    }
    return /* @__PURE__ */ react.createElement(Receipt_PatientLaserReceipt, {
      invoice
    });
  }
}
LaserReceiptPrint_ComponentToPrint.propTypes = {
  classes: prop_types_default().shape({}).isRequired,
  invoice: prop_types_default().shape({
    invoiceNumber: (prop_types_default()).string,
    payers: prop_types_default().arrayOf(prop_types_default().shape({})),
    patient: prop_types_default().shape({}),
    lineItems: prop_types_default().arrayOf(prop_types_default().shape({}))
  }).isRequired,
  invoicesToPrint: prop_types_default().arrayOf((prop_types_default()).string).isRequired,
  printReceiptOnly: (prop_types_default()).bool
};
LaserReceiptPrint_ComponentToPrint.defaultProps = {
  printReceiptOnly: false
};
class LaserReceiptPrint_ReactToPrintRemoteTrigger extends (lib_default()) {
  render() {
    return /* @__PURE__ */ react.createElement("div", null);
  }
}
const LaserReceiptPrint = (props) => {
  const { onAfterPrint } = props;
  const componentRef = (0,react.useRef)();
  const receiptRef = (0,react.useRef)();
  const classes = LaserReceiptPrint_useStyles();
  (0,react.useEffect)(() => {
    receiptRef.current.handleClick();
  }, [receiptRef]);
  return /* @__PURE__ */ react.createElement("div", {
    "data-testid": "laser-printing"
  }, /* @__PURE__ */ react.createElement(LaserReceiptPrint_ReactToPrintRemoteTrigger, {
    ref: receiptRef,
    content: () => componentRef.current,
    pageStyle: "@page{ size: a5; } @media print{ }",
    onAfterPrint
  }), /* @__PURE__ */ react.createElement("div", {
    className: classes.containerWrapper
  }, /* @__PURE__ */ react.createElement(LaserReceiptPrint_ComponentToPrint, {
    ref: componentRef,
    classes,
    ...props
  })));
};
LaserReceiptPrint.propTypes = {
  onAfterPrint: (prop_types_default()).func.isRequired,
  invoice: prop_types_default().shape({}).isRequired,
  invoicesToPrint: prop_types_default().arrayOf((prop_types_default()).string).isRequired,
  printReceiptOnly: (prop_types_default()).bool
};
LaserReceiptPrint.defaultProps = {
  printReceiptOnly: false
};
/* harmony default export */ const Receipt_LaserReceiptPrint = (LaserReceiptPrint);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PrintableLaserReceipt.tsx





const PrintableLaserReceipt_ERROR_MESSAGE = (0,lib/* defineMessage */.Em)({
  id: "invoicing.getInvoice.error.msg",
  defaultMessage: "Failed to fetch this invoice"
});
const PrintableLaserReceipt = ({
  invoiceId,
  onAfterPrint
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { data, loading, error } = (0,useFetchPrintableInvoice/* default */.Z)(invoiceId, {
    fetchPolicy: "network-only"
  });
  if (loading) {
    return null;
  }
  if (error) {
    dist_default().error(formatMessage(PrintableLaserReceipt_ERROR_MESSAGE));
    onAfterPrint();
    return null;
  }
  return /* @__PURE__ */ react.createElement(Receipt_LaserReceiptPrint, {
    onAfterPrint,
    invoice: data.invoice,
    printReceiptOnly: true,
    invoicesToPrint: []
  });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/ramda@0.27.0/node_modules/ramda/es/isEmpty.js + 1 modules
var isEmpty = __webpack_require__(3549);
// EXTERNAL MODULE: ./src/client/forms/validation/ValidationContext.ts
var ValidationContext = __webpack_require__(35831);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/useUpdatePatientDetails.ts
var useUpdatePatientDetails = __webpack_require__(51341);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/useFetchPatientDetails.tsx + 1 modules
var useFetchPatientDetails = __webpack_require__(18921);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/patientTypeFormHelpers.ts




function patientTypeFormHelpers_useValidationSchema() {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return (0,react.useMemo)(
    () => (0,es.object)({
      [PATIENT_TYPE]: (0,es.mixed)().oneOf([OUTPATIENT, INPATIENT]),
      [INPATIENT_DETAILS]: (0,es.object)().when(PATIENT_TYPE, {
        is: (patientType) => {
          return patientType === INPATIENT;
        },
        then: (0,es.object)({
          [WARD]: (0,es.string)().required(),
          [INPATIENT_NUMBER]: (0,es.string)().matches(
            /^[A-Za-z0-9]+$/,
            formatMessage({
              id: "invoicing.inpatientNumber.input.error",
              defaultMessage: "Inpatient number can only contain alphanumeric characters"
            })
          ).required(),
          [ADMISSION_DATE]: (0,es.date)().nullable(),
          [DISCHARGE_DATE]: (0,es.date)().nullable().min(
            (0,es.ref)(ADMISSION_DATE),
            formatMessage({
              id: "invoicing.admissionDate.input.error",
              defaultMessage: "Discharge date can not be before Admission date"
            })
          )
        })
      })
    }),
    [formatMessage]
  );
}

// EXTERNAL MODULE: ./src/client/forms/hookForm/fields/TextField.tsx
var fields_TextField = __webpack_require__(73306);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/InpatientForm.tsx








const InpatientForm_useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  label: {
    color: theme.palette.darkerGrey.main
  },
  ward: {
    width: "100%"
  }
}));
const InpatientForm = () => {
  const classes = InpatientForm_useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { control } = (0,index_esm/* useFormContext */.Gc)();
  const WARD_FIELD = `${INPATIENT_DETAILS}.${WARD}`;
  const INPATIENT_NUMBER_FIELD = `${INPATIENT_DETAILS}.${INPATIENT_NUMBER}`;
  const ADMISSION_DATE_FIELD = `${INPATIENT_DETAILS}.${ADMISSION_DATE}`;
  const DISCHARGE_DATE_FIELD = `${INPATIENT_DETAILS}.${DISCHARGE_DATE}`;
  const wardMsg = formatMessage({
    id: "invoicing.inpatient.ward",
    defaultMessage: "Ward"
  });
  const inpatientNumberMsg = formatMessage({
    id: "invoicing.inpatient.inpatientNumber",
    defaultMessage: "Patient Number"
  });
  const admissionDateMsg = formatMessage({
    id: "invoicing.inpatient.admissionDate",
    defaultMessage: "Admission Date"
  });
  const dischargeDateMsg = formatMessage({
    id: "invoicing.inpatient.dischargeDate",
    defaultMessage: "Discharge Date"
  });
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 8
  }, /* @__PURE__ */ react.createElement(fields_TextField/* default */.Z, {
    name: WARD_FIELD,
    required: true,
    label: wardMsg,
    placeholder: wardMsg,
    "data-testid": "invoicing.ward.field",
    InputLabelProps: {
      classes: { root: classes.label }
    },
    inputProps: { min: "1" },
    className: classes.ward
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 4
  }, /* @__PURE__ */ react.createElement(fields_TextField/* default */.Z, {
    name: INPATIENT_NUMBER_FIELD,
    required: true,
    label: inpatientNumberMsg,
    placeholder: inpatientNumberMsg,
    "data-testid": "invoicing.inpatientNumber.field",
    InputLabelProps: {
      classes: { root: classes.label }
    },
    inputProps: {
      min: "1"
    }
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, /* @__PURE__ */ react.createElement(index_esm/* Controller */.Qr, {
    control,
    name: ADMISSION_DATE_FIELD,
    render: ({
      field: { onChange, onBlur, value },
      fieldState: { error }
    }) => /* @__PURE__ */ react.createElement(mui_input_dist_module/* DatePicker */.Mt, {
      label: admissionDateMsg,
      onChange,
      onBlur,
      value,
      error: error == null ? void 0 : error.message,
      "aria-labelledby": admissionDateMsg,
      onKeyDown: (e) => {
        e.preventDefault();
      },
      "data-testid": "invoicing.inpatient.dateOfAdmission"
    })
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, /* @__PURE__ */ react.createElement(index_esm/* Controller */.Qr, {
    control,
    name: DISCHARGE_DATE_FIELD,
    render: ({
      field: { onChange, onBlur, value },
      fieldState: { error }
    }) => /* @__PURE__ */ react.createElement(mui_input_dist_module/* DatePicker */.Mt, {
      name: DISCHARGE_DATE_FIELD,
      label: dischargeDateMsg,
      onChange,
      onBlur,
      value,
      error: error == null ? void 0 : error.message,
      "aria-labelledby": dischargeDateMsg,
      onKeyDown: (e) => {
        e.preventDefault();
      },
      "data-testid": "invoicing.inpatient.dateOfDischarge"
    })
  }))));
};
/* harmony default export */ const InvoiceDetails_InpatientForm = (InpatientForm);

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/PatientTypeSection.tsx


















const useServiceOptions = () => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return (0,react.useMemo)(
    () => [
      {
        value: OUTPATIENT,
        label: formatMessage({
          id: "invoicing.patientType.radioInput.option.outpatient",
          defaultMessage: "Outpatient"
        }),
        "data-testid": "invoicing.patientType.outpatient"
      },
      {
        value: INPATIENT,
        label: formatMessage({
          id: "invoicing.patientType.radioInput.option.inpatient",
          defaultMessage: "Inpatient"
        }),
        "data-testid": "invoicing.patientType.inpatient"
      }
    ],
    [formatMessage]
  );
};
const PatientTypeSection = ({
  invoiceId,
  editable,
  dispatcher,
  busy
}) => {
  const servicesOptions = useServiceOptions();
  const validationSchema = patientTypeFormHelpers_useValidationSchema();
  const { patientType, inpatientDetails: inpatient } = (0,useFetchPatientDetails/* default */.Z)(invoiceId);
  const defaultValues = {
    patientType: patientType || InvoiceCard_types/* PatientType.OUTPATIENT */.l.OUTPATIENT,
    inpatientDetails: !(0,isEmpty/* default */.Z)(inpatient) ? inpatient : {
      ward: null,
      inpatientNumber: null,
      admission: null,
      discharge: null
    }
  };
  const patientTypeFormMethods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    reValidateMode: "onChange",
    resolver: (0,yup/* yupResolver */.X)(validationSchema),
    defaultValues
  });
  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid, isDirty }
  } = patientTypeFormMethods;
  const patient = (0,index_esm/* useWatch */.qo)({
    name: PATIENT_TYPE,
    defaultValue: defaultValues.patientType,
    control
  });
  const inpatientDetails = (0,index_esm/* useWatch */.qo)({
    name: INPATIENT_DETAILS,
    defaultValue: defaultValues.inpatientDetails,
    control
  });
  const { updatePatientDetails, loading } = (0,useUpdatePatientDetails/* default */.Z)(
    patient,
    inpatientDetails,
    invoiceId
  );
  const savePatientDetails = async (formValues) => {
    dispatcher.sendBusy();
    try {
      await updatePatientDetails(formValues);
    } finally {
      dispatcher.sendBusy(false);
    }
  };
  (0,react.useEffect)(() => {
    reset({ patientType, inpatientDetails: inpatient });
  }, [inpatient, patientType, reset]);
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: editable
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(ValidationContext/* default.Provider */.Z.Provider, {
    value: { validationSchema }
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...patientTypeFormMethods
  }, /* @__PURE__ */ react.createElement("form", {
    name: "PatientTypeForm",
    onSubmit: handleSubmit(savePatientDetails)
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFRadioField */.ov, {
    name: PATIENT_TYPE,
    options: servicesOptions,
    required: true
  }), patient === INPATIENT && /* @__PURE__ */ react.createElement(InvoiceDetails_InpatientForm, null), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    pt: 2,
    textAlign: "right"
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "secondary",
    type: "submit",
    disabled: !isDirty || !isValid || busy,
    loading,
    startIcon: /* @__PURE__ */ react.createElement(Save/* default */.Z, null),
    "data-testid": "invoicing.savePatientDetails.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.patientDetails.save",
    defaultMessage: "Save patient details"
  }))))))))), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !editable
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, /* @__PURE__ */ react.createElement("b", null, patient)), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !!(inpatientDetails == null ? void 0 : inpatientDetails.ward)
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.patienType.ward",
    defaultMessage: "Ward:"
  }), ` ${inpatientDetails == null ? void 0 : inpatientDetails.ward}`)), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !!(inpatientDetails == null ? void 0 : inpatientDetails.inpatientNumber)
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.patienType.patientNumber",
    defaultMessage: "Patient No:"
  }), ` ${inpatientDetails == null ? void 0 : inpatientDetails.inpatientNumber}`)), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    justifyContent: "space-between"
  }, /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !!(inpatientDetails == null ? void 0 : inpatientDetails.admission)
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.patienType.admission",
    defaultMessage: "From:"
  }), (inpatientDetails == null ? void 0 : inpatientDetails.admission) && ` ${(0,format/* default */.Z)(
    new Date(inpatientDetails.admission),
    "dd/MM/yyyy"
  )}`)), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !!(inpatientDetails == null ? void 0 : inpatientDetails.discharge)
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "subtitle2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.patienType.discharge",
    defaultMessage: "To:"
  }), (inpatientDetails == null ? void 0 : inpatientDetails.discharge) && ` ${(0,format/* default */.Z)(
    new Date(inpatientDetails.discharge),
    "dd/MM/yyyy"
  )}`))))));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/hooks/useInvoiceDetailsDispatcher.ts

var InvoiceDetailsActionType = /* @__PURE__ */ ((InvoiceDetailsActionType2) => {
  InvoiceDetailsActionType2[InvoiceDetailsActionType2["Busy"] = 0] = "Busy";
  return InvoiceDetailsActionType2;
})(InvoiceDetailsActionType || {});
class InvoiceDetailsDispatcher {
  constructor(dispatch) {
    this.dispatch = dispatch;
  }
  sendBusy(busy) {
    this.dispatch({ type: 0 /* Busy */, value: busy != null ? busy : true });
  }
}
const defaultState = {
  busy: false
};
function useInvoiceDetailsDispatcher(reducer, initialState) {
  const [state, dispatch] = (0,react.useReducer)(reducer, {
    ...defaultState,
    ...initialState
  });
  const dispatcher = new InvoiceDetailsDispatcher(dispatch);
  return [state, dispatcher];
}

// EXTERNAL MODULE: ./src/client/utils/useFacility.ts
var useFacility = __webpack_require__(41075);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/InvoiceDetails.tsx

























const defaultBalanceState = {
  number: 0,
  formatted: "-"
};
function calculateBalance(total, insuranceAmount, patientPayer, status, currencyFormatter) {
  var _a, _b, _c, _d, _e;
  if (status.hasLineItems && !status.paymentIsDue) {
    return { number: 0, formatted: currencyFormatter(0) };
  }
  const patientPaid = patientPayer ? ((_a = patientPayer.balance) == null ? void 0 : _a.paid) + ((_c = (_b = patientPayer.balance) == null ? void 0 : _b.exempt) != null ? _c : 0) + ((_e = (_d = patientPayer.balance) == null ? void 0 : _d.waived) != null ? _e : 0) : 0;
  const calculatedBalance = total - insuranceAmount - patientPaid;
  const formattedBalance = calculatedBalance >= 0 && status.hasLineItems ? currencyFormatter(calculatedBalance) : "-";
  return { number: calculatedBalance, formatted: formattedBalance };
}
const stateReducer = (prevState, action) => {
  var _a;
  switch (action.type) {
    case InvoiceDetailsActionType.Busy: {
      return { ...prevState, busy: Boolean((_a = action.value) != null ? _a : true) };
    }
    default:
      throw new Error(`invalid action: ${JSON.stringify(action)}`);
  }
};
const InvoiceDetails = ({
  invoiceId,
  priceList,
  insurers,
  setSummaryBalance,
  setSummaryTotal,
  isNewInvoice,
  facility
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const {
    data: { id: currentFacilityId }
  } = (0,useFacility/* default */.Z)();
  const userCanEditInvoice = currentFacilityId === facility.id;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { currencyFormatter } = (0,useCurrencyFormatter/* default */.Z)();
  const permissions = (0,usePermissions/* usePermissions */.TE)();
  const [isEditMode, setIsEditMode] = (0,react.useState)(isNewInvoice);
  const [deleteModal, setDeleteModal] = (0,react.useState)(false);
  const [voidModal, setVoidModal] = (0,react.useState)(false);
  const [paymentModal, setPaymentModal] = (0,react.useState)(false);
  const [exemptModal, setExemptModal] = (0,react.useState)(false);
  const [finaliseModal, setFinaliseModal] = (0,react.useState)(false);
  const [refundModal, setRefundModal] = (0,react.useState)(false);
  const [printPermissionsModal, setPrintPermissionModal] = (0,react.useState)(false);
  const [printPayerSelectionModal, setPrintPayerSelectionModal] = (0,react.useState)(false);
  const [printPayerNames, setPrintPayerNames] = (0,react.useState)([]);
  const [printInvoice, setPrintInvoice] = (0,react.useState)(false);
  const [printLaserReceipt, setPrintLaserReceipt] = (0,react.useState)(false);
  const [hasLineItems, setHasLineItems] = (0,react.useState)(null);
  const [paymentHistoryModal, setPaymentHistoryModal] = (0,react.useState)(false);
  const [total, setTotal] = (0,react.useState)(defaultBalanceState);
  const [insuranceAmount, setInsuranceAmount] = (0,react.useState)(defaultBalanceState);
  const { invoice, error } = (0,useFetchInvoice/* default */.Z)(invoiceId);
  const [state, dispatcher] = useInvoiceDetailsDispatcher(stateReducer, {
    busy: false
  });
  const isPriceListVersionSame = (() => {
    if (!invoice || !priceList) {
      return false;
    }
    if (invoice.lineItems.length === 0) {
      return true;
    }
    const hasUuid = !!invoice.lineItems[0].priceListItem.uuid;
    return hasUuid && priceList.version === 1 || !hasUuid && priceList.version === 2;
  })();
  const {
    havePrinter,
    printReceipt,
    resetErrors: resetPrinterErrors,
    printerError,
    fetchError
  } = (0,usePrintThermalReceipt/* default */.Z)(invoiceId);
  const patientInsurance = (_a = invoice == null ? void 0 : invoice.patient) == null ? void 0 : _a.insurance;
  const invoicePayers = (invoice == null ? void 0 : invoice.payers) || [];
  const payers = invoicePayers.filter((p) => p.type !== formConstants/* PATIENT */.rL);
  const patientPayer = invoicePayers.find((p) => p.type === "PATIENT");
  const hasRefundableBalance = ((_c = (_b = patientPayer == null ? void 0 : patientPayer.balance) == null ? void 0 : _b.paid) != null ? _c : 0) > 0;
  const invoiceActions = {
    displayOptions: getDisplayOptions(invoice),
    printInvoice: {
      handlePrintInvoice: () => {
        if (invoicePayers.length > 1) {
          setPrintPayerSelectionModal(true);
        } else {
          setPrintInvoice(true);
        }
      },
      handlePrintReceipt: async () => {
        const printerAvailable = await havePrinter();
        if (printerAvailable) {
          await printReceipt();
        } else {
          setPrintPermissionModal(true);
        }
      },
      disabled: isEditMode
    },
    deleteInvoice: { handleAction: () => setDeleteModal(true) },
    takePayment: { handleAction: () => setPaymentModal(true) },
    voidInvoice: { handleAction: () => setVoidModal(true) },
    refundInvoice: {
      handleAction: () => setRefundModal(true),
      hide: !hasRefundableBalance
    },
    paymentHistory: { handleAction: () => setPaymentHistoryModal(true) },
    finaliseInvoice: {
      handleAction: () => setFinaliseModal(true),
      hide: isEditMode
    }
  };
  const invoiceBalance = (0,react.useMemo)(
    () => calculateBalance(
      total.number,
      insuranceAmount.number,
      patientPayer,
      { paymentIsDue: invoice == null ? void 0 : invoice.paymentIsDue, hasLineItems },
      currencyFormatter
    ),
    [
      total.number,
      insuranceAmount.number,
      invoice == null ? void 0 : invoice.paymentIsDue,
      patientPayer,
      hasLineItems,
      currencyFormatter
    ]
  );
  const totalPayableInPence = (0,react.useMemo)(
    () => {
      var _a2, _b2, _c2, _d2;
      return (_d2 = (_c2 = (_b2 = (_a2 = invoice == null ? void 0 : invoice.payers) == null ? void 0 : _a2.find((p) => p.type === "PATIENT")) == null ? void 0 : _b2.balance) == null ? void 0 : _c2.due) != null ? _d2 : 0;
    },
    [invoice == null ? void 0 : invoice.payers]
  );
  const handleSetTotal = (0,react.useCallback)(
    (totalToSet) => {
      const formattedTotal = currencyFormatter(totalToSet);
      setTotal({ number: totalToSet, formatted: formattedTotal });
      setSummaryTotal(formattedTotal);
    },
    [currencyFormatter, setTotal, setSummaryTotal]
  );
  const handleSetInsuranceAmount = (0,react.useCallback)(
    (paidToSet) => {
      const formattedPaid = currencyFormatter(paidToSet || 0);
      setInsuranceAmount({ number: paidToSet, formatted: formattedPaid });
    },
    [currencyFormatter]
  );
  (0,react.useEffect)(() => {
    setSummaryBalance(invoiceBalance.formatted);
  }, [invoiceBalance, setSummaryBalance]);
  if (!invoice || !priceList)
    return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      p: 2,
      width: "100%",
      textAlign: "center"
    }, /* @__PURE__ */ react.createElement(CircularProgress/* default */.Z, null));
  if (error)
    return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      p: 3
    }, /* @__PURE__ */ react.createElement(ErrorPage/* default */.Z, {
      error
    }));
  const hasLineItemsFromFetch = invoice.lineItems.length > 0;
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    textAlign: "right"
  }, /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: (invoice == null ? void 0 : invoice.invoiceStatus) === InvoiceFilters/* InvoiceStatus.Draft */.UY.Draft
  }, /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !isPriceListVersionSame
  }, /* @__PURE__ */ react.createElement(Tooltip/* default */.ZP, {
    title: formatMessage({
      id: "invoicing.invoice.editDisabled.priceListVersion",
      defaultMessage: "Editing is disabled when a different price list is being used"
    })
  }, /* @__PURE__ */ react.createElement(HelpOutline/* default */.Z, {
    color: "primary"
  }))), userCanEditInvoice && /* @__PURE__ */ react.createElement(EditSwitch/* EditSwitch */.k, {
    editable: isEditMode,
    toggleEdit: setIsEditMode,
    disabled: !isPriceListVersionSame || state.busy
  })))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(PatientTypeSection, {
    invoiceId,
    editable: isEditMode,
    dispatcher,
    busy: state.busy
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, priceList.version === 1 ? /* @__PURE__ */ react.createElement(LineItemSection, {
    invoiceId,
    invoice,
    priceList,
    editable: isEditMode,
    setHasLineItems,
    hasLineItems: hasLineItems != null ? hasLineItems : hasLineItemsFromFetch,
    total: total.number,
    setTotal: handleSetTotal,
    dispatcher,
    busy: state.busy
  }) : /* @__PURE__ */ react.createElement(LineItemSectionV2, {
    invoiceId,
    invoice,
    priceList,
    editable: isEditMode,
    setHasLineItems,
    hasLineItems: hasLineItems != null ? hasLineItems : hasLineItemsFromFetch,
    total: total.number,
    setTotal: handleSetTotal,
    dispatcher,
    busy: state.busy
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(InsurerSection, {
    canAddInsurers: true,
    hasLineItems: hasLineItems != null ? hasLineItems : hasLineItemsFromFetch,
    payers,
    insurers,
    totalAmount: total.number,
    invoiceId,
    patientInsurance,
    editable: isEditMode,
    paid: insuranceAmount.number,
    setPaid: handleSetInsuranceAmount,
    isDraft: (invoice == null ? void 0 : invoice.invoiceStatus) === InvoiceFilters/* InvoiceStatus.Draft */.UY.Draft,
    dispatcher,
    busy: state.busy
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Divider/* default */.Z, null), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    py: 2,
    textAlign: "right"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "inline-block",
    pr: 1
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    gutterBottom: true
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.details.insurers",
    defaultMessage: "Insurance"
  }), ": "), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    gutterBottom: true
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.details.balance",
    defaultMessage: "Balance"
  }), ": "), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    gutterBottom: true
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "invoicing.invoice.details.total",
    defaultMessage: "Total"
  }), ": ")), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "inline-block"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    gutterBottom: true
  }, /* @__PURE__ */ react.createElement("strong", null, insuranceAmount.formatted)), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    gutterBottom: true
  }, /* @__PURE__ */ react.createElement("strong", null, invoiceBalance.formatted)), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    gutterBottom: true
  }, /* @__PURE__ */ react.createElement("strong", null, total.formatted))))), userCanEditInvoice && /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(InvoiceActions/* InvoiceActions */.hA, {
    ...invoiceActions
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: deleteModal
  }, /* @__PURE__ */ react.createElement(modals/* DeleteInvoiceModal */.Vt, {
    open: deleteModal,
    onClose: () => setDeleteModal(false),
    invoiceId
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: finaliseModal
  }, /* @__PURE__ */ react.createElement(modals/* FinaliseInvoiceModal */.vQ, {
    invoiceId,
    open: finaliseModal,
    onClose: () => setFinaliseModal(false)
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: voidModal
  }, /* @__PURE__ */ react.createElement(modals/* VoidInvoiceModal */.it, {
    invoiceId,
    open: voidModal,
    onClose: () => setVoidModal(false)
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: paymentModal
  }, /* @__PURE__ */ react.createElement(modals/* TakePaymentModal */.zI, {
    invoiceId,
    currency: invoice.currencyCode,
    totalPayableInPence: (_e = (_d = patientPayer == null ? void 0 : patientPayer.balance) == null ? void 0 : _d.due) != null ? _e : 0,
    waiveable: permissions.waive,
    exemptable: permissions.exemption && ((_f = invoice == null ? void 0 : invoice.payers) == null ? void 0 : _f.every((p) => p.type === "PATIENT")),
    open: paymentModal,
    onClose: () => setPaymentModal(false),
    openExempt: () => setExemptModal(true)
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: exemptModal
  }, /* @__PURE__ */ react.createElement(modals/* ExemptModal */.tN, {
    open: exemptModal,
    onClose: () => {
      setExemptModal(false);
      setPaymentModal(false);
    },
    onCancel: () => {
      setExemptModal(false);
    },
    invoiceId,
    currency: invoice.currencyCode,
    totalPayableInPence
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: refundModal
  }, /* @__PURE__ */ react.createElement(modals/* RefundInvoiceModal */._S, {
    invoiceId,
    currency: invoice.currencyCode,
    totalRefundableInPence: (_h = (_g = patientPayer == null ? void 0 : patientPayer.balance) == null ? void 0 : _g.paid) != null ? _h : 0,
    open: refundModal,
    onClose: () => setRefundModal(false)
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: !!(printerError != null ? printerError : fetchError)
  }, /* @__PURE__ */ react.createElement(modals/* PrintErrorModal */.XN, {
    error: printerError != null ? printerError : fetchError,
    onClose: resetPrinterErrors,
    onUseLaser: () => {
      resetPrinterErrors();
      setPrintLaserReceipt(true);
    },
    onRetry: async () => {
      resetPrinterErrors();
      await invoiceActions.printInvoice.handlePrintReceipt();
    }
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: printPermissionsModal
  }, /* @__PURE__ */ react.createElement(modals/* PrintPermissionsModal */.be, {
    onClose: () => setPrintPermissionModal(false),
    onConnect: async () => {
      setPrintPermissionModal(false);
      await printReceipt();
    },
    onUseLaser: () => {
      setPrintPermissionModal(false);
      setPrintLaserReceipt(true);
    }
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: paymentHistoryModal
  }, /* @__PURE__ */ react.createElement(modals/* PaymentHistoryModal */.RH, {
    invoiceId,
    currency: invoice.currencyCode,
    open: paymentHistoryModal,
    onClose: () => setPaymentHistoryModal(false)
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: printPayerSelectionModal
  }, /* @__PURE__ */ react.createElement(PrintPayerSelectionModal/* PrintPayerSelectionModal */.a, {
    payers: invoicePayers,
    onClose: () => setPrintPayerSelectionModal(false),
    onSelection: (payerNames) => {
      setPrintPayerNames(payerNames);
      setPrintInvoice(true);
    }
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: printInvoice
  }, /* @__PURE__ */ react.createElement(InvoiceDetails_PrintableInvoice_PrintableInvoice, {
    invoiceId,
    payerNames: printPayerNames,
    onAfterPrint: () => setPrintInvoice(false)
  })), /* @__PURE__ */ react.createElement(ConditionalDisplay/* ConditionalDisplay */.f, {
    condition: printLaserReceipt
  }, /* @__PURE__ */ react.createElement(PrintableLaserReceipt, {
    invoiceId,
    onAfterPrint: () => setPrintLaserReceipt(false)
  })));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceDetails/index.ts


;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/InvoiceCard.tsx










const InvoiceCard = ({
  invoiceId,
  invoiceSummary,
  priceList,
  insurers,
  balance
}) => {
  const visibleRef = (0,react.useRef)(null);
  const navigate = (0,dist/* useNavigate */.s0)();
  const location = (0,dist/* useLocation */.TH)();
  const isDraft = invoiceSummary.invoiceStatus === InvoiceFilters/* InvoiceStatus.Draft */.UY.Draft;
  const inTheLast10Minutes = dayjs_min_default()(new Date()).subtract(10, "minute");
  const isNewInvoice = dayjs_min_default()(invoiceSummary.created) > inTheLast10Minutes;
  const currency = (0,useCurrencyFormat/* default */.Z)();
  const convertFromPence = (0,useConvertCurrency/* useConvertFromPenceFactory */.YQ)();
  const query = (0,useQuerystring/* default */.Z)();
  const [expanded, setExpanded] = (0,react.useState)(
    isDraft && isNewInvoice || invoiceId === (query == null ? void 0 : query.invoiceId)
  );
  const [summaryBalance, setSummaryBalance] = (0,react.useState)(
    currency.format(convertFromPence(balance.due))
  );
  const [summaryTotal, setSummaryTotal] = (0,react.useState)(
    currency.format(convertFromPence(balance.total))
  );
  (0,react.useEffect)(() => {
    if (invoiceId === query.invoiceId) {
      if (visibleRef.current) {
        visibleRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    }
  }, []);
  const handleChange = (_event, hasExpanded) => {
    const { pathname, search } = location;
    const params = new URLSearchParams(search);
    params.set("invoiceId", invoiceId);
    if (hasExpanded) {
      navigate({ pathname, search: params.toString() }, { replace: true });
    }
  };
  const invoiceSummaryProps = {
    ...invoiceSummary,
    balance: summaryBalance,
    total: summaryTotal,
    expanded,
    setExpanded
  };
  return /* @__PURE__ */ react.createElement("div", {
    ref: visibleRef,
    "data-testid": `invoice-card-${invoiceId.toLowerCase()}`
  }, /* @__PURE__ */ react.createElement(Accordion/* default */.Z, {
    TransitionProps: { unmountOnExit: true },
    expanded,
    onChange: handleChange,
    elevation: 4
  }, /* @__PURE__ */ react.createElement(AccordionSummary/* default */.Z, null, /* @__PURE__ */ react.createElement(InvoiceSummary, {
    ...invoiceSummaryProps
  })), /* @__PURE__ */ react.createElement(AccordionDetails/* default */.Z, null, /* @__PURE__ */ react.createElement(InvoiceDetails, {
    invoiceId,
    priceList,
    insurers,
    setSummaryBalance,
    setSummaryTotal,
    isNewInvoice,
    invoiceStatus: invoiceSummary.invoiceStatus,
    facility: invoiceSummary.facility
  }))));
};


/***/ })

}]);